import React, { Suspense, lazy, useEffect } from "react";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import { URL } from "./utils/routes";
import { LoggedInRoute, ProtectedRoutes } from "./utils/ProtectedRoutes";
import ViewEmployeeTrainingRequisition from "./app/dashboard/Pages/Employee/Training/ViewTrainingRequisition";
import ViewAccidentReport from "./app/dashboard/Pages/Fleets/Accident/ViewAccidentReport";
import ViewMaintenanceRequisition from "./app/dashboard/Pages/Fleets/Maintenance/ViewMaintenanceRequisition";
import ViewFleet from "./app/dashboard/Pages/Fleets/AllFleets/ViewFleet";
import { DEFINED_PERMISSIONS } from "./utils/const";
import { getMyPermissions } from "./utils/functions/GetMyPermissions";
import AnalyseCompanyFunds from "./app/dashboard/Pages/Finance/AnalyseCompanyFund";
import Cashbook from "./app/dashboard/Pages/Finance/AnalyseCompanyFund/Cashbook";
import CostCenterClass from "./app/dashboard/Pages/Finance/CostCenter/Class";
import CostCenterClassSetup from "./app/dashboard/Pages/Finance/CostCenter/ClassSetup";
import CostCenterDetails from "./app/dashboard/Pages/Finance/CostCenter/Details";
import CostCenterServiceSetup from "./app/dashboard/Pages/Finance/CostCenter/Setup";
import CostCenterExpensesDetails from "./app/dashboard/Pages/Finance/CostCenterExpenses/Details";
import Keywords from "./app/dashboard/Pages/Finance/AnalyseCompanyFund/Keywords";
import RecommendInvestmentAmount from "./app/dashboard/Pages/Finance/AnalyseCompanyFund/Recommend";
import Recommendations from "./app/dashboard/Pages/Finance/AnalyseCompanyFund/Recommendations";
import SetupKeyword from "./app/dashboard/Pages/Finance/AnalyseCompanyFund/SetupKeyword";
import UploadBankStatement from "./app/dashboard/Pages/Finance/AnalyseCompanyFund/UploadBankStatement";
import PaymentDetails from "./app/dashboard/Pages/Finance/PaymentRequest/PaymentDetails.js";
import PaymentRequest from "./app/dashboard/Pages/Finance/PaymentRequest/PaymentRequest.js";
import PaymentType from "./app/dashboard/Pages/Finance/PaymentSetup/Payment-Setup-HOD/PaymentTypes";
import { GetLocalStorage } from "./utils/functions/GetLocalStorage";
import { USER_CATEGORY } from "./utils/Enums";
import RouteLayout from "./app/dashboard/Components/Layout/RouteLayout";
import EditExitRequisition from "./app/dashboard/Pages/Employee/ExitRequisition/EditExitRequisition";
import MedicalRequisition from "./app/dashboard/Pages/HR/EmployeeManagement/MedicalUpdate/MedicalRequisition";
import Palliative from "./app/dashboard/Pages/Palliative/index.js";
import AddPayroll from "./app/dashboard/Pages/HR/PayrollSetup/AddPayroll";
import ViewTrainingRequisition from "./app/dashboard/Pages/HR/Training/ViewTrainingRequisition.js";
import UpdateWeekendAllowance from "./app/dashboard/Pages/Employee/WeekendAllowance/UpdateWeekendAllowance.js";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import PaymentRequestControl from "./app/dashboard/Pages/Finance/PaymentRequest/PaymentRequestControl.js";
import SetupAService from "./app/dashboard/Pages/Finance/SetupAService/index.jsx";
import BookAService from "./app/dashboard/Pages/Finance/BookAService/index.jsx";
import PaymentRequestControl2 from "./app/dashboard/Pages/Finance/PaymentRequest/PaymentRequestControl2.js";
import ServiceDetailsView from "./app/dashboard/Pages/Finance/SetupAService/view.jsx";
import WitholdingTaxSetup from "./app/dashboard/Pages/Finance/PaymentSetup/Payment-Setup-HOD/WitholdingTaxSetup.js";
import ExchangeRateSetup from "./app/dashboard/Pages/Finance/PaymentSetup/Payment-Setup-HOD/ExchangeRateSetup";
import PaymentRecognitionSetup from "./app/dashboard/Pages/Finance/PaymentSetup/Payment-Setup-HOD/PaymentRecognitionSetup.js";
import CreateNewService from "./app/dashboard/Pages/Finance/SetupAService/createNewService.jsx";
import AddFacilities from "./app/dashboard/Pages/Finance/SetupAService/AddFacilitiesComponents.jsx";
import UpdateService from "./app/dashboard/Pages/Finance/SetupAService/UpdateService.jsx";
import ServiceBookingDetails from "./app/dashboard/Pages/Finance/BookAService/services/view.jsx";
import UpdateServiceBookings from "./app/dashboard/Pages/Finance/BookAService/bookings/update.jsx";
import BookingsServiceDetails from "./app/dashboard/Pages/Finance/BookAService/bookings/view.jsx";
import ManageBookingRequest from "./app/dashboard/Pages/Finance/ManageBooking/index.jsx";
import ManageBookingRequestView from "./app/dashboard/Pages/Finance/ManageBooking/view.jsx";
import ViewAuxiliaryRequest from "./app/dashboard/Pages/Employee/AuxiliaryServiceRequest/ViewAuxiliaryRequest.js";
import UpdateAuxiliaryRequest from "./app/dashboard/Pages/Employee/AuxiliaryServiceRequest/UpdateAuxiliaryRequest.js";
import ViewRepaymentPlanSetup from "./app/dashboard/Pages/HR/RepaymentPlanSetup/ViewRepaymentPlanSetup.js";
import SetupAnAccount from "./app/dashboard/Pages/Finance/AccountSetup/index.jsx";
import AttachAccountDetails from "./app/dashboard/Pages/Finance/AccountSetup/createNewService.jsx";
import AccountDetailsView from "./app/dashboard/Pages/Finance/AccountSetup/view.jsx";
import CreateBookingsA from "./app/dashboard/Pages/Finance/BookAService/bookings/CreateBookingsA.jsx";
import RecommendEdit from "./app/dashboard/Pages/Finance/AnalyseCompanyFund/RecommendEdit.js";
import ViewRecommendations from "./app/dashboard/Pages/Finance/AnalyseCompanyFund/ViewRecommendations.js";
import BudgetImportDetailsView from "./app/dashboard/Pages/Finance/BudgetImport/BudgetImportDetails/WitholdingTaxDetails.js";
import AddAssetMaintenanceRequisition from "./app/dashboard/Pages/Assets/Maintenance/AddAssetMaintenanceRequisition.js";
import EditAssetMaintenanceRequisition from "./app/dashboard/Pages/Assets/Maintenance/EditAssetMaintenanceRequisition.js";
import ViewAssetMaintenanceRequisition from "./app/dashboard/Pages/Assets/Maintenance/ViewAssetMaintenanceRequisition.js";
import JobListingDetails from "./app/dashboard/Pages/HR/JobListSetup/JobListingDetails.js";
import InitiateRecruitment from "./app/dashboard/Pages/HR/RecruitmentService/InitiateRecruitment";
import RecruitmentProcessOverview from "./app/dashboard/Pages/HR/RecruitmentService/RecruitmentProcessOverview.js";
import RecruitmentProcessDetails from "./app/dashboard/Pages/HR/RecruitmentService/RecruitmentProcessDetails.js";
import UpdateRecruitment from "./app/dashboard/Pages/HR/RecruitmentService/UpdateRecruitment.js";
import JobApplicationForm from "./app/JobApplication/JobApplicationForm.jsx";
import RecruitmentReviewGroup from "./app/dashboard/Pages/HR/RecruitmentService/RecruitmentReviewGroup.js";
import UploadMedicalForm from "./app/dashboard/Pages/HR/RecruitmentService/UploadMedicalForm.jsx";
import RecruitmentProcessOverviewEd from "./app/dashboard/Pages/HR/RecruitmentService/RecruitmentProcessOverviewEd.js";
import RecruitmentProcessOverviewMd from "./app/dashboard/Pages/HR/RecruitmentService/RecruitmentProcessOverviewMd.js";
import ViewApplicantOffer from "./app/JobApplication/ViewApplicantOffer.js";
import EmployeeService from "./app/dashboard/Pages/Employee/EmployeeService/index.jsx";
import CreditFacility from "./app/dashboard/Pages/Finance/CreditFacility/index.js";
import AddCreditFacility from "./app/dashboard/Pages/Finance/CreditFacility/addCreditFacility.js";
import GenerateReports from "./app/dashboard/Pages/Reports/TriggerHistory";
import ViewVendorPayment from "./app/dashboard/Pages/Procurement/VendorPayment/veiwVendorPayment.js";
import Management from "./app/dashboard/Pages/Management/index.js";
import ControlReview from "./app/dashboard/Pages/ControlReview/index.js";
import PaymentLog from "./app/dashboard/Pages/Finance/PaymentRequest/paymentLog.js";
import { HRAppraisalSetup } from "./app/dashboard/Pages/HR/Appraisal/Setup";
import { CreateObjectives } from "./app/dashboard/Pages/HR/Appraisal/CreatObjectives.jsx";
import KeyResultArea from "./app/dashboard/Pages/HR/Appraisal/KeyResultArea.jsx";
import AppraisalPeriod from "./app/dashboard/Pages/HR/Appraisal/AppraisalPeriod.jsx";
import RatingScale from "./app/dashboard/Pages/HR/Appraisal/RatingScale.jsx";
import { ViewSingleRatingScale } from "./app/dashboard/Pages/HR/Appraisal/views/ViewSingleRatingScale.jsx";
import ScoreRecommendation from "./app/dashboard/Pages/HR/Appraisal/ScoreRecommendation.jsx";
import StatusLabel from "./app/dashboard/Pages/HR/Appraisal/StatusLabel.jsx";
import { ViewStatusLabel } from "./app/dashboard/Pages/HR/Appraisal/views/ViewStatusLabel.jsx";
import CounselingType from "./app/dashboard/Pages/HR/Appraisal/CounselingType.jsx";
import { ViewCounsellingType } from "./app/dashboard/Pages/HR/Appraisal/views/ViewCounsellingType.jsx";
import { ViewScoreBased } from "./app/dashboard/Pages/HR/Appraisal/views/ViewScoreBased.jsx";
import { ViewAppraisalPeriod } from "./app/dashboard/Pages/HR/Appraisal/views/ViewAppraisalPeriod.jsx";
import { ViewAppraisalObjective } from "./app/dashboard/Pages/HR/Appraisal/views/ViewAppraisalObjective.jsx";
import SelfAppraialView from "./app/dashboard/Pages/Employee/SelfAppraisal/SelfAppraial.jsx";

import PerformanceImprovementPlan from "./app/dashboard/Pages/HR/Appraisal/PIP.jsx";
import { ViewKeyResultArea } from "./app/dashboard/Pages/HR/Appraisal/views/ViewKeyResultArea.jsx";
import SelfAppraisal from "./app/dashboard/Pages/Employee/SelfAppraisal/index.jsx";
import { ViewPIP } from "./app/dashboard/Pages/HR/Appraisal/views/ViewPIP.jsx";
import ManagementAppraisal from "./app/dashboard/Pages/Management/AppraisalReviewManagement/index.jsx";
import { ViewManagementAppraisal } from "./app/dashboard/Pages/Management/AppraisalReview/view.jsx";
import AppraisalReviewManagement from "./app/dashboard/Pages/Management/AppraisalReview/index.jsx";
import { ViewAppraisalManagementReview } from "./app/dashboard/Pages/Management/AppraisalReviewManagement/view.jsx";
import PerformanceAppraisal from "./app/dashboard/Pages/Employee/PeerReview/index.jsx";
import PeerReview from "./app/dashboard/Pages/Employee/PeerReview/PeerReview.jsx";
import UpwardReview from "./app/dashboard/Pages/Employee/PeerReview/UpwardReview.jsx";
import CrossReview from "./app/dashboard/Pages/Employee/PeerReview/CrossReview.jsx";
import { ViewCrossReview } from "./app/dashboard/Pages/Employee/PeerReview/view/ViewCrossReview.jsx";
import { ViewUpwardReview } from "./app/dashboard/Pages/Employee/PeerReview/view/ViewUpwardReview.jsx";
import { ViewPeerReview } from "./app/dashboard/Pages/Employee/PeerReview/view/ViewPeerReview.jsx";
import LineManagerProcesses from "./app/dashboard/Pages/Employee/LineManagerAppraisal/index.jsx";
import LineManagerView from "./app/dashboard/Pages/Employee/LineManagerAppraisal/LineManagerView.jsx";
import CommitteeList from "./app/dashboard/Pages/HR/Appraisal/CommitteeList.jsx";
import CommitteeListView from "./app/dashboard/Pages/HR/Appraisal/views/CommitteeListView.jsx";
import EmployeePIP from "./app/dashboard/Pages/Employee/EmployeePIP/index.jsx";
import { ViewEmployeePIP } from "./app/dashboard/Pages/Employee/EmployeePIP/EmployeePIPView.jsx";
import { ViewSingleMainPIP } from "./app/dashboard/Pages/HR/Appraisal/views/ViewSingleMainPIP.jsx";
import EmployeeProcRequisition from "./app/dashboard/Pages/Employee/ProcurementRequisition/index.js";
import AddEmployeeProcRequisition from "./app/dashboard/Pages/Employee/ProcurementRequisition/AddRequisition.js";
// import AddEmployeeProcRequisition from "./app/dashboard/Pages/Employee/ProcurementRequisition";
import ViewEmployeeProcRequisition from "./app/dashboard/Pages/Employee/ProcurementRequisition/ViewRequisition.js";
import GeneralSetup from "./app/dashboard/Pages/HR/GeneralSetup/Index.jsx";
import DevelopmentPlan from "./app/dashboard/Pages/HR/Appraisal/DevelopmentPlan.jsx";
import ExpectedImprovementPlan from "./app/dashboard/Pages/HR/Appraisal/ExpectedImprovementPlan.jsx";
import { ViewDevelopmentPlan } from "./app/dashboard/Pages/HR/Appraisal/views/ViewDevelopmentPlan.jsx";
import { ViewExpectedImprovementPlan } from "./app/dashboard/Pages/HR/Appraisal/views/ViewExpectedImprovementPlan.jsx";
import HRAppraisal from "./app/dashboard/Pages/HR/HrAppraisal/index.jsx";
import { ViewHRAppraisal } from "./app/dashboard/Pages/HR/HrAppraisal/view.jsx";

const ViewIndividualCreditFacility = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/CreditFacility/veiwIndividualCreditFacility.js"
  )
);
const WitholdingTaxDetails = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/PaymentSetup/Payment-Setup-HOD/WitholdingTaxDetails.js"
  )
);
const UpdateGroup = lazy(() =>
  import("./app/dashboard/Pages/Finance/AccountingSetup/UpdateGroup")
);
const UpdateSubgroup = lazy(() =>
  import("./app/dashboard/Pages/Finance/AccountingSetup/UpdateSubgroup")
);
const AccountingLedger = lazy(() =>
  import("./app/dashboard/Pages/Finance/AccountingLedger/AccountingLedger")
);
const SeniorAccountant = lazy(() =>
  import("./app/dashboard/Pages/Finance/AccountingLedger/SeniorAccountant")
);
const PendingApprovalTwo = lazy(() =>
  import("./app/dashboard/Pages/Finance/AccountingLedger/PendingApprovalTwo")
);
const PendingApproval = lazy(() =>
  import("./app/dashboard/Pages/Finance/AccountingSetup/PendingApproval")
);
const CreateCOA = lazy(() =>
  import("./app/dashboard/Pages/Finance/AccountingSetup/CreateCOA")
);
const CreateAccountingAcct = lazy(() =>
  import("./app/dashboard/Pages/Finance/AccountingSetup/CreateAccountingAcct")
);
const CreateSubAcct = lazy(() =>
  import("./app/dashboard/Pages/Finance/AccountingSetup/CreateSubAcct")
);
const AccountingSetupIndex = lazy(() =>
  import("./app/dashboard/Pages/Finance/AccountingSetup/AccountingSetupIndex")
);
const DetailPaymentComp = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/DetailPaymentComp")
);

const PaymentServiceHistory = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/PaymentServiceHistory")
);
const DetailPaymentSubclass = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/DetailPaymentSubclass")
);
const EditPaymentSubclass = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/EditPaymentSubclass")
);
const DetailPaymentSetup = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/DetailPaymentSetup")
);

const PaymentServiceIndex = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/PaymentServiceIndex")
);
const CreatePaymentSetup = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/CreatePaymentSetup")
);
const EditPaymentSetup = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/EditPaymentSetup")
);
const CreateSubclassComp = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/CreateSubclassComp")
);
const CreatePaymentSubclass = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/CreatePaymentSubclass")
);
const UpdateSubclassComp = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/UpdateSubclassComp")
);
const SetupPaymentLimit = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/SetupPaymentLimit")
);
const UpdatePaymentLimit = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/UpdatePaymentLimit")
);
const PaymentService = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentService/PaymentService")
);

const CostCenter = lazy(() =>
  import("./app/dashboard/Pages/Finance/CostCenter")
);
const CostCenterExpenses = lazy(() =>
  import("./app/dashboard/Pages/Finance/CostCenterExpenses")
);
const PayrollAutorun = lazy(() =>
  import("./app/dashboard/Pages/Finance/PayrollAutoRun/PayrollAutoRun")
);

const PayrollRun = lazy(() =>
  import("./app/dashboard/Pages/Finance/PayrollAutoRun/pages/PayrollRun")
);

const ViewStaffRemunerations = lazy(() =>
  import("./app/dashboard/Pages/Finance/PayrollAutoRun/pages/ViewStaff")
);

const Payment = lazy(() =>
  import("./app/dashboard/Pages/Finance/Payment/Payment")
);
const PaymentSetup = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentSetup/Payment-Setup")
);
const PaymentSetupHOD = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/PaymentSetup/Payment-Setup-HOD/Payment-Setup-HOD"
  )
);
const Narration = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/PaymentSetup/Payment-Setup-HOD/Narration"
  )
);
const ManageRoles = lazy(() =>
  import("./app/dashboard/Pages/Finance/PaymentSetup/Manage-Roles/Manage-Roles")
);
const CooperativeSetup = lazy(() =>
  import("./app/dashboard/Pages/Finance/CooperativeSetup/Cooperative-Setup")
);
const CooperativeComponent = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/CooperativeSetup/CooperativeComponent/Cooperative-Component"
  )
);
const CreateCooperativeComponent = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/CooperativeSetup/CooperativeComponent/CreateCooperativeComponent/CreateCooperativeComponent"
  )
);
const EditCooperativeSetup = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/CooperativeSetup/CooperativeSetupDetails/EditSetup"
  )
);

const CooperativeSetupDetails = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/CooperativeSetup/CooperativeSetupDetails/CooperativeSetupDetails"
  )
);
const BudgetImport = lazy(() =>
  import("./app/dashboard/Pages/Finance/BudgetImport/BudgetImport")
);
const BudgetImportDetails = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/BudgetImport/BudgetImportDetails/BudgetImportDetails"
  )
);
const CooperativeManagement = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/CooperativeManagement/CooperativeManagement"
  )
);
const CooperativeManagementApproval = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/CooperativeManagement/CooperativeManagementApproval/CooperativeManagementApproval"
  )
);
const CooperativeManagementApprovalDetails = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/CooperativeManagement/CooperativeManagementApproval/CooperativeManagementApprovalDetails"
  )
);
const CooperativeManagementReviewer = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/CooperativeManagement/CooperativeManagementReviewer/CooperativeManagementReviewer"
  )
);
const CooperativeManagementReviewerDetails = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/CooperativeManagement/CooperativeManagementReviewer/CooperativeManagementReviewerDetails"
  )
);

// TODO
const NonStatutoryAdviceManagement = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/NonStatutoryAdviceManagement/NonStatutoryAdviceManagement"
  )
);
const NonStatutoryAdviceApproval = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/NonStatutoryAdviceManagement/NonStatutoryAdviceApproval/NonStatutoryAdviceApproval"
  )
);
const NonStatutoryAdviceApprovalDetails = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/NonStatutoryAdviceManagement/NonStatutoryAdviceApproval/NonStatutoryAdviceApprovalDetails"
  )
);
const NonStatutoryAdviceReviewer = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/NonStatutoryAdviceManagement/NonStatutoryAdviceReviewer"
  )
);
const NonStatutoryAdviceReviewerDetails = lazy(() =>
  import(
    "./app/dashboard/Pages/Finance/NonStatutoryAdviceManagement/NonStatutoryAdviceReviewerDetails"
  )
);

const Showcase = lazy(() => import("./app/showcase"));
const Home = lazy(() => import("./app/auth"));
const Login = lazy(() => import("./app/auth/Login"));
const ForgotPassword = lazy(() => import("./app/auth/ForgotPasswordPro"));
const ResetPassword = lazy(() => import("./app/auth/ResetPasswordPro"));
const JobPosting = lazy(() => import("./app/JobApplication/JobPosting"));
const SignUp = lazy(() => import("./app/auth/SignUp"));
const EmailConfirm = lazy(() => import("./app/auth/EmailConfirmation"));
const Dashboard = lazy(() => import("./app/dashboard"));
const DashboardHome = lazy(() => import("./app/dashboard/Pages/DashboardHome"));
const Onboarding = lazy(() => import("./app/dashboard/Onboarding.js"));
const Assets = lazy(() => import("./app/dashboard/Pages/Assets"));
const AssetMaintenanceRequisitions = lazy(() =>
  import(
    "./app/dashboard/Pages/Assets/Maintenance/AssetMaintenanceRequisitions.js"
  )
);
const VehicleMaintenance = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Maintenance/AllMaintenanceRequisitions")
);
const VehicleMaintenanceRequsition = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Maintenance/AddRequisition")
);
const EditVehicleMaintenanceRequsition = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Maintenance/EditMaintenanceRequisition")
);
const AccidentReport = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Accident/AllAccidentReport")
);
const AddAccidentReport = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Accident/AddAccidentReport")
);
const EditAccidentReport = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Accident/EditAccidentReport")
);
const VendorsMgt = lazy(() =>
  import("./app/dashboard/Pages/Vendors/Management")
);
const VendorsHome = lazy(() =>
  import("./app/dashboard/Pages/Vendors/Management/Vendor")
);
const AddVendor = lazy(() =>
  import("./app/dashboard/Pages/Vendors/Management/AddVendor.jsx")
);

const CreateVendor = lazy(() =>
  import("./app/dashboard/Pages/Vendors/Management/CreateVendor")
);

const EditVendor = lazy(() =>
  import("./app/dashboard/Pages/Vendors/Management/EditVendor")
);

const AppraiseVendor = lazy(() =>
  import("./app/dashboard/Pages/Vendors/Management/AppraiseVendor")
);
const ViewVendor = lazy(() =>
  import("./app/dashboard/Pages/Vendors/Management/ViewVendors")
);

// EMPLOYEE
const EmployeeVendorsHome = lazy(() =>
  import("./app/dashboard/Pages/Employee/Vendors/Management/index.js")
);
const EmployeeAddVendor = lazy(() =>
  import("./app/dashboard/Pages/Employee/Vendors/Management/AddVendor.jsx")
);

const EmployeeCreateVendor = lazy(() =>
  import("./app/dashboard/Pages/Employee/Vendors/Management/CreateVendor")
);

const EmployeeEditVendor = lazy(() =>
  import("./app/dashboard/Pages/Employee/Vendors/Management/EditVendor")
);

const EmployeeViewVendor = lazy(() =>
  import("./app/dashboard/Pages/Employee/Vendors/Management/ViewVendors")
);

const Procurement = lazy(() => import("./app/dashboard/Pages/Procurement"));
const ProcDeliveryHome = lazy(() =>
  import("./app/dashboard/Pages/Procurement/Delivery")
);
const ProcQuotationDeliveryView = lazy(() =>
  import("./app/dashboard/Pages/Procurement/Delivery/ViewDelivery")
);
const ProcQuotationHome = lazy(() =>
  import("./app/dashboard/Pages/Procurement/Quotation")
);
const ProcQuotationAdd = lazy(() =>
  import("./app/dashboard/Pages/Procurement/Quotation/AddQuotation")
);
const ProcQuotationAddDeliveryNote = lazy(() =>
  import("./app/dashboard/Pages/Procurement/Quotation/AddQuotationDelivery")
);
const ProcQuotationView = lazy(() =>
  import("./app/dashboard/Pages/Procurement/Quotation/ViewQuotation")
);

const ControlQuotationHome = lazy(() =>
  import("./app/dashboard/Pages/ControlReview/Quotation")
);

const ControlQuotationView = lazy(() =>
  import("./app/dashboard/Pages/ControlReview/Quotation/ViewQuotation")
);

const ProcRequisitionHome = lazy(() =>
  import("./app/dashboard/Pages/Procurement/Requisition")
);
const ProcRequisitionAdd = lazy(() =>
  import("./app/dashboard/Pages/Procurement/Requisition/AddRequisition")
);
const ProcRequisitionView = lazy(() =>
  import("./app/dashboard/Pages/Procurement/Requisition/ViewRequisition")
);

const ProcRequisitionWaivers = lazy(() =>
  import("./app/dashboard/Pages/Procurement/Waivers")
);
const ProcRequisitionWaiverView = lazy(() =>
  import("./app/dashboard/Pages/Procurement/Waivers/ViewWaiver[deleted].js")
);
const Acquisition = lazy(() =>
  import("./app/dashboard/Pages/Assets/Acquisition/Acquisition")
);
const AddAcquisition = lazy(() =>
  import("./app/dashboard/Pages/Assets/Acquisition/AddNewAcquisition")
);
const ViewAcquisition = lazy(() =>
  import("./app/dashboard/Pages/Assets/Acquisition/ViewAcquisition")
);

const Allocation = lazy(() =>
  import("./app/dashboard/Pages/Assets/Allocation/Allocation")
);
const AddAllocation = lazy(() =>
  import("./app/dashboard/Pages/Assets/Allocation/AddNewAllocation")
);
const ViewAllocation = lazy(() =>
  import("./app/dashboard/Pages/Assets/Allocation/ViewAllocation")
);

const Monitoring = lazy(() =>
  import("./app/dashboard/Pages/Assets/Monitoring/Monitoring")
);
const AddMonitoring = lazy(() =>
  import("./app/dashboard/Pages/Assets/Monitoring/AddNewMonitoring")
);
const ViewMonitoring = lazy(() =>
  import("./app/dashboard/Pages/Assets/Monitoring/ViewMonitoring")
);

const AuctioningBidding = lazy(() =>
  import("./app/dashboard/Pages/Assets/Auctioning (Bidding)/AuctioningBidding")
);

const ViewAuctioningBidding = lazy(() =>
  import(
    "./app/dashboard/Pages/Assets/Auctioning (Bidding)/ViewAuctioningBidding"
  )
);

const Auctioning = lazy(() =>
  import("./app/dashboard/Pages/Assets/Auctioning/Auctioning")
);

const AddAuctioning = lazy(() =>
  import("./app/dashboard/Pages/Assets/Auctioning/AddNewAuctioning")
);
const ViewAuctioning = lazy(() =>
  import("./app/dashboard/Pages/Assets/Auctioning/ViewAuctioning")
);

const AssetRequisition = lazy(() =>
  import("./app/dashboard/Pages/Assets/Requisition/Requisition")
);
const AssetDepreciation = lazy(() =>
  import(
    "./app/dashboard/Pages/AssetsSetUp/AssetDepreciation/AssetDepreciation"
  )
);
const AddRequisition = lazy(() =>
  import("./app/dashboard/Pages/Assets/Requisition/AddNewRequisition")
);
const ViewAssetRequisition = lazy(() =>
  import("./app/dashboard/Pages/Assets/Requisition/ViewRequisition")
);

const AssetRegister = lazy(() =>
  import("./app/dashboard/Pages/AssetsSetUp/AssetRegister/AssetRegister")
);
const AddAssetRegister = lazy(() =>
  import("./app/dashboard/Pages/AssetsSetUp/AssetRegister/AddAssetRegister")
);
const ViewAssetRegister = lazy(() =>
  import("./app/dashboard/Pages/AssetsSetUp/AssetRegister/ViewAssetRegister")
);
const EditAssetRegister = lazy(() =>
  import("./app/dashboard/Pages/AssetsSetUp/AssetRegister/EditAssetRegister")
);
const Categories = lazy(() =>
  import("./app/dashboard/Pages/AssetsSetUp/Categories/Categories")
);
const AddCategories = lazy(() =>
  import("./app/dashboard/Pages/AssetsSetUp/Categories/AddNewCategories")
);
const ViewCategories = lazy(() =>
  import("./app/dashboard/Pages/AssetsSetUp/Categories/ViewCategories")
);

const ConsummablesRegister = lazy(() =>
  import(
    "./app/dashboard/Pages/ConsummableSetUp/ConsummableRegister/ConsummableRegister"
  )
);
const AddConsummablesRegister = lazy(() =>
  import(
    "./app/dashboard/Pages/ConsummableSetUp/ConsummableRegister/AddConsummableRegister"
  )
);
const ViewConsummablesRegister = lazy(() =>
  import(
    "./app/dashboard/Pages/ConsummableSetUp/ConsummableRegister/ViewConsummableRegister"
  )
);
const EditConsummablesRegister = lazy(() =>
  import(
    "./app/dashboard/Pages/ConsummableSetUp/ConsummableRegister/EditConsummableRegister"
  )
);
const ConsummablesCategories = lazy(() =>
  import(
    "./app/dashboard/Pages/ConsummableSetUp/ConsummableCategories/ConsummableCategories"
  )
);
const AddConsummablesCategories = lazy(() =>
  import(
    "./app/dashboard/Pages/ConsummableSetUp/ConsummableCategories/AddNewConsummableCategories"
  )
);
const ViewConsummablesCategories = lazy(() =>
  import(
    "./app/dashboard/Pages/ConsummableSetUp/ConsummableCategories/ViewConsummableCategories"
  )
);

const Budget = lazy(() =>
  import("./app/dashboard/Pages/AssetsSetUp/Budget/Budget")
);

const ConsumableAcquisition = lazy(() =>
  import("./app/dashboard/Pages/Consumables/Acquisition/Acquisition")
);
const AddConsumableAcquisition = lazy(() =>
  import("./app/dashboard/Pages/Consumables/Acquisition/AddNewAcquisition")
);
const ViewConsumableAcquisition = lazy(() =>
  import("./app/dashboard/Pages/Consumables/Acquisition/ViewAcquisition")
);

const ConsumableAllocation = lazy(() =>
  import("./app/dashboard/Pages/Consumables/Allocation/Allocation")
);
const AddConsumableAllocation = lazy(() =>
  import("./app/dashboard/Pages/Consumables/Allocation/AddNewAllocation")
);
const ViewConsumableAllocation = lazy(() =>
  import("./app/dashboard/Pages/Consumables/Allocation/AddNewAllocation")
);

const ConsumableRequisition = lazy(() =>
  import("./app/dashboard/Pages/Consumables/Requisition/Requisition")
);
const AddConsumableRequisition = lazy(() =>
  import("./app/dashboard/Pages/Consumables/Requisition/AddNewRequisition")
);
const ViewConsumableRequisition = lazy(() =>
  import("./app/dashboard/Pages/Consumables/Requisition/ViewRequisition")
);
//hr
const HR = lazy(() => import("./app/dashboard/Pages/HR"));
const TrainingSetup = lazy(() =>
  import("./app/dashboard/Pages/HR/TrainingSetUp")
);
const TrainingRequisitions = lazy(() =>
  import("./app/dashboard/Pages/HR/Training")
);

const MyRecruitmentSetUp = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentService")
);

const AddApplicant = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentService/AddApplicant")
);

const ViewApplicant = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentService/ViewApplicant")
);

const UpdateApplicant = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentService/UpdateApplicant")
);

const SigninApplicant = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentService/SignInApplicant")
);

const MyInitiateRecruitment = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentService/InitiateRecruitment")
);
const RecruitmentDetails = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentService/RecruitmentDetails")
);

const RecruitmentProcess = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentService/RecruitmentProcess")
);

const RecruitmentReviewDetails = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentService/RecruitmentReviewDetails")
);

const RecruitmentComment = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentService/RecruitmentComment")
);

const ScheduleInterview = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentService/ScheduleInterview")
);

const JobApplication = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentService/JobApplication")
);

const RecruitmentSetUp = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentSetUp")
);
const SetupJobtitle = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentSetUp/SetupJobtitle")
);

const JobTitleDetails = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentSetUp/JobTitleDetails")
);

const JobTitleUpdate = lazy(() =>
  import("./app/dashboard/Pages/HR/RecruitmentSetUp/JobTitleUpdate")
);

const SetSkills = lazy(() => import("./app/dashboard/Pages/HR/SetSkills"));

const SetUpSkills = lazy(() =>
  import("./app/dashboard/Pages/HR/SetSkills/SetupSkills")
);

const SkillsDetails = lazy(() =>
  import("./app/dashboard/Pages/HR/SetSkills/SkillsDetails")
);

const SkillsUpdate = lazy(() =>
  import("./app/dashboard/Pages/HR/SetSkills/SkillsUpdate")
);

const QualificationSetup = lazy(() =>
  import("./app/dashboard/Pages/HR/QualificationSetup")
);

const SetupQualification = lazy(() =>
  import("./app/dashboard/Pages/HR/QualificationSetup/SetUpQualification")
);

const QualificationDetails = lazy(() =>
  import("./app/dashboard/Pages/HR/QualificationSetup/QualificationDetails")
);

const QualificationUpdate = lazy(() =>
  import("./app/dashboard/Pages/HR/QualificationSetup/QualificationUpdate")
);

const MetricsSetup = lazy(() =>
  import("./app/dashboard/Pages/HR/MetricCommand")
);

const SetupMetrics = lazy(() =>
  import("./app/dashboard/Pages/HR/MetricCommand/MetricsSetup")
);

const MetricsDetails = lazy(() =>
  import("./app/dashboard/Pages/HR/MetricCommand/MetricsDetails")
);

const MetricsUpdate = lazy(() =>
  import("./app/dashboard/Pages/HR/MetricCommand/MetricsUpdate")
);

const ApplicationChannelSetup = lazy(() =>
  import("./app/dashboard/Pages/HR/Application")
);

const JobListSetup = lazy(() =>
  import("./app/dashboard/Pages/HR/JobListSetup")
);

const SetupJoblisting = lazy(() =>
  import("./app/dashboard/Pages/HR/JobListSetup/SetupJoblisting")
);

const SetApplicationChannel = lazy(() =>
  import("./app/dashboard/Pages/HR/Application/SetApplicationChannel")
);

const ApplicationChannelDetails = lazy(() =>
  import("./app/dashboard/Pages/HR/Application/ApplicationChannelDetails")
);

const ApplicationUpdate = lazy(() =>
  import("./app/dashboard/Pages/HR/Application/ApplicationUpdate")
);

const AttendanceClock = lazy(() =>
  import("./app/dashboard/Pages/HR/AttendanceClock")
);

const ClockSetting = lazy(() =>
  import("./app/dashboard/Pages/HR/AttendanceClock/ClockSetting")
);

const UpdateClock = lazy(() =>
  import("./app/dashboard/Pages/HR/AttendanceClock/UpdateClock")
);

const ClockSetup = lazy(() =>
  import("./app/dashboard/Pages/HR/AttendanceClock/ClockSetup")
);

const EmployeeGroup = lazy(() =>
  import("./app/dashboard/Pages/HR/EmployeeGroup")
);

const AddEmployeeGroup = lazy(() =>
  import("./app/dashboard/Pages/HR/EmployeeGroup/AddEmployeeGroup")
);

const UpdateEmployeeGroup = lazy(() =>
  import("./app/dashboard/Pages/HR/EmployeeGroup/UpdateEmployeeGroup")
);

const ViewEmployeeGroup = lazy(() =>
  import("./app/dashboard/Pages/HR/EmployeeGroup/ViewEmployeeGroup")
);

const EmployeeCadrePosition = lazy(() =>
  import("./app/dashboard/Pages/HR/EmployeeCadrePosition")
);

const AddEmployeeCadrePosition = lazy(() =>
  import(
    "./app/dashboard/Pages/HR/EmployeeCadrePosition/AddEmployeeCadrePosition"
  )
);
const UpdateEmployeeCadrePosition = lazy(() =>
  import(
    "./app/dashboard/Pages/HR/EmployeeCadrePosition/UpdateEmployeeCadrePosition"
  )
);

const ViewEmployeeCadrePosition = lazy(() =>
  import(
    "./app/dashboard/Pages/HR/EmployeeCadrePosition/ViewEmployeeCadrePosition"
  )
);

const EmployeeCadrePositionLevel = lazy(() =>
  import("./app/dashboard/Pages/HR/EmployeeCadrePositionLevel")
);

const AddEmployeeCadrePositionLevel = lazy(() =>
  import(
    "./app/dashboard/Pages/HR/EmployeeCadrePositionLevel/AddEmployeeCadrePositionLevel"
  )
);
const UpdateEmployeeCadrePositionLevel = lazy(() =>
  import(
    "./app/dashboard/Pages/HR/EmployeeCadrePositionLevel/UpdateEmployeeCadrePositionLevel"
  )
);

const ViewEmployeeCadrePositionLevel = lazy(() =>
  import(
    "./app/dashboard/Pages/HR/EmployeeCadrePositionLevel/ViewEmployeeCadrePositionLevel"
  )
);

const LoanSetup = lazy(() => import("./app/dashboard/Pages/HR/LoanSetup"));

const AddLoan = lazy(() =>
  import("./app/dashboard/Pages/HR/LoanSetup/AddLoanSetup")
);

const UpdateLoan = lazy(() =>
  import("./app/dashboard/Pages/HR/LoanSetup/UpdateLoan")
);

const LoanRuleSetup = lazy(() => import("./app/dashboard/Pages/HR/LoanRule"));

const AddLoanRule = lazy(() =>
  import("./app/dashboard/Pages/HR/LoanRule/AddLoanRule")
);

const UpdateLoanRule = lazy(() =>
  import("./app/dashboard/Pages/HR/LoanRule/UpdateLoanRule")
);

const LoanRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/LoanRequisition")
);

const AddLoanRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/LoanRequisition/AddRequisition")
);

const UpdateLoanRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/LoanRequisition/UpdateRequisition")
);

const ViewLoanRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/LoanRequisition/ViewLoanRequisition")
);

const EmployeeMedicalRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/EmployeeMedicalRequisitions")
);

const AddMedicalRequisition = lazy(() =>
  import(
    "./app/dashboard/Pages/Employee/EmployeeMedicalRequisitions/AddMedicalRequisition"
  )
);

const UpdateMedicalRequisition = lazy(() =>
  import(
    "./app/dashboard/Pages/Employee/EmployeeMedicalRequisitions/UpdateMedicalRequisition"
  )
);

const ViewMedicalRequisition = lazy(() =>
  import(
    "./app/dashboard/Pages/Employee/EmployeeMedicalRequisitions/ViewMedicalRequisition"
  )
);

const ExtendHMOClaims = lazy(() =>
  import("./app/dashboard/Pages/Employee/ExtendedHMOClaims")
);

const AddExtendHMOClaims = lazy(() =>
  import("./app/dashboard/Pages/Employee/ExtendedHMOClaims/AddExtended")
);

const ViewExtendHMOClaimss = lazy(() =>
  import("./app/dashboard/Pages/Employee/ExtendedHMOClaims/ViewExtended")
);

const UpdateExtendHMOClaims = lazy(() =>
  import("./app/dashboard/Pages/Employee/ExtendedHMOClaims/UpdateExtended")
);

const Directorate = lazy(() => import("./app/dashboard/Pages/HR/Directorate"));

const AddDirectorate = lazy(() =>
  import("./app/dashboard/Pages/HR/Directorate/AddDirectorate")
);

const UpdateDirectorate = lazy(() =>
  import("./app/dashboard/Pages/HR/Directorate/UpdateDirectorate")
);

const ViewDirectorate = lazy(() =>
  import("./app/dashboard/Pages/HR/Directorate/ViewDirectorate")
);

const PaymentRequisition = lazy(() =>
  import("./app/dashboard/Pages/PaymentRequisition")
);

const AddPaymentRequisition = lazy(() =>
  import("./app/dashboard/Pages/PaymentRequisition/AddPaymentRequisition")
);

const UpdatePaymentRequisition = lazy(() =>
  import("./app/dashboard/Pages/PaymentRequisition/UpdatePaymentRequisition")
);

const ViewPaymentRequisition = lazy(() =>
  import("./app/dashboard/Pages/PaymentRequisition/ViewPaymentRequisition")
);

const EmployeePaymentRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/PaymentRequisition")
);

const AddEmployeePaymentRequisition = lazy(() =>
  import(
    "./app/dashboard/Pages/Employee/PaymentRequisition/AddPaymentRequisition"
  )
);

const UpdateEmployeePaymentRequisition = lazy(() =>
  import(
    "./app/dashboard/Pages/Employee/PaymentRequisition/UpdatePaymentRequisition"
  )
);

const ViewEmployeePaymentRequisition = lazy(() =>
  import(
    "./app/dashboard/Pages/Employee/PaymentRequisition/ViewPaymentRequisition"
  )
);

const AuxiliaryServiceRequest = lazy(() =>
  import("./app/dashboard/Pages/Employee/AuxiliaryServiceRequest")
);

const AddAuxiliaryRequest = lazy(() =>
  import(
    "./app/dashboard/Pages/Employee/AuxiliaryServiceRequest/AddAuxiliaryRequest"
  )
);

const WeekendAllowanceForEmployee = lazy(() =>
  import("./app/dashboard/Pages/Employee/WeekendAllowance")
);

const WeekendAllowanceForHod = lazy(() =>
  import("./app/dashboard/Pages/Employee/WeekendAllowance/WeekendAllowanceHod")
);

// const WeekendAllowanceForControl = lazy(() =>
//   import(
//     "./app/dashboard/Pages/ControlReview/WeekendAllowance/WeekendAllowanceControl"
//   )
// );

const AddWeekendAllowance = lazy(() =>
  import("./app/dashboard/Pages/Employee/WeekendAllowance/AddWeekendAllowance")
);

const PayrollStructure = lazy(() =>
  import("./app/dashboard/Pages/HR/PayrollStructure")
);

const AddPayrollStructure = lazy(() =>
  import("./app/dashboard/Pages/HR/PayrollStructure/AddPayrollStructure")
);
const UpdatePayrollStructure = lazy(() =>
  import("./app/dashboard/Pages/HR/PayrollStructure/UpdatePayrollStructure")
);

const ViewPayrollStructure = lazy(() =>
  import("./app/dashboard/Pages/HR/PayrollStructure/ViewPayrollStructure")
);
const Fleet = lazy(() => import("./app/dashboard/Pages/Fleets"));
const Fleets = lazy(() => import("./app/dashboard/Pages/Fleets/AllFleets"));
const DocumentSetup = lazy(() =>
  import("./app/dashboard/Pages/Fleets/VehicleDocument/SetUp")
);
const Requisition = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Requisition/Requisition")
);

//employee
const Employee = lazy(() => import("./app/dashboard/Pages/Employee"));
const EmployeeTrainingRequisitions = lazy(() =>
  import("./app/dashboard/Pages/Employee/Training")
);
const EditTrainingRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/Training/EditTrainingRequsition")
);
const AddTrainingRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/Training/AddTrainingRequisition")
);

const MyRequisitions = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Requisition/MyRequisitions")
);
const AddFuelRequisition = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Requisition/AddNewFuelRequisition")
);
const ViewRequisition = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Requisition/ViewFuelRequisition")
);
const EditRequisition = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Requisition/EditRequisition")
);
const FuelPayment = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Payment/FuelPayment")
);
const AddFuelPayment = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Payment/AddNewFuelPayment")
);
const ViewPayment = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Payment/ViewPayment")
);
const EditPayment = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Payment/EditPayment")
);
const MyPayment = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Payment/MyPayment")
);
const DriverActivity = lazy(() =>
  import("./app/dashboard/Pages/Fleets/DriverActivities/DriverActivity")
);
const AddActivity = lazy(() =>
  import("./app/dashboard/Pages/Fleets/DriverActivities/AddActivity")
);
const EditActivity = lazy(() =>
  import("./app/dashboard/Pages/Fleets/DriverActivities/EditActivity")
);
const ViewDriverActivity = lazy(() =>
  import("./app/dashboard/Pages/Fleets/DriverActivities/ViewDriverActivity")
);
const AllDriverActivities = lazy(() =>
  import("./app/dashboard/Pages/Fleets/DriverActivities/AllDriverActivities")
);
const FleetMovementSummary = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Movement/Summaries")
);
const FleetMovementSummaryDetails = lazy(() =>
  import("./app/dashboard/Pages/Fleets/Movement/ViewDetails")
);

const Scheduler = lazy(() =>
  import("./app/dashboard/Pages/Fleets/DriverActivities/Scheduler")
);

const Permissions = lazy(() =>
  import("./app/dashboard/Pages/Settings/Permissions")
);

const GroupPermissions = lazy(() =>
  import("./app/dashboard/Pages/Settings/GroupPermissions")
);

const ViewGroupPermissions = lazy(() =>
  import("./app/dashboard/Pages/Settings/GroupPermissions/ViewPermissionGroup")
);

const AddGroupPermissions = lazy(() =>
  import("./app/dashboard/Pages/Settings/GroupPermissions/AddPermissionGroup")
);

const CreateStaff = lazy(() =>
  import("./app/dashboard/Pages/Settings/Permissions/CreateStaff")
);

const EditStaffPermission = lazy(() =>
  import("./app/dashboard/Pages/Settings/Permissions/EditStaffPermissions")
);

const ReportIndex = lazy(() => import("./app/dashboard/Pages/Reports/index"));
const ReportsAdd = lazy(() => import("./app/dashboard/Pages/Reports/add"));
const ReportTriggerHistory = lazy(() =>
  import("./app/dashboard/Pages/Reports/TriggerHistory")
);

const LeaveRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/Leave/LeaveRequistion")
);
const AddLeave = lazy(() =>
  import("./app/dashboard/Pages/Employee/Leave/AddLeave")
);

const ViewLeave = lazy(() =>
  import("./app/dashboard/Pages/Employee/Leave/ViewLeave")
);

const EditLeave = lazy(() =>
  import("./app/dashboard/Pages/Employee/Leave/EditLeave")
);

const LeaveApprovalHOD = lazy(() =>
  import(
    "./app/dashboard/Pages/Employee/Leave/LeaveApprovalHOD/LeaveApprovalHOD"
  )
);

const LeaveApproval = lazy(() =>
  import("./app/dashboard/Pages/HR/LeaveApproval/LeaveApproval")
);
const LeaveRecall = lazy(() =>
  import("./app/dashboard/Pages/HR/LeaveRecall/LeaveRecall")
);

const ViewRecall = lazy(() =>
  import("./app/dashboard/Pages/HR/LeaveRecall/LeaveRecall")
);
const LeaveSetUp = lazy(() =>
  import("./app/dashboard/Pages/HR/LeaveSetUp/index")
);

const PayrollSetup = lazy(() =>
  import("./app/dashboard/Pages/HR/PayrollSetup/")
);

const PayrollComponentTable = lazy(() =>
  import("./app/dashboard/Pages/HR/PayrollSetup/PayrollComponentTable")
);

const PayTest = lazy(() =>
  import("./app/dashboard/Pages/HR/PayrollSetup/PayTest")
);

const PayTester = lazy(() =>
  import("./app/dashboard/Pages/HR/PayrollSetup/PayTester")
);

const Ori = lazy(() => import("./app/dashboard/Pages/HR/PayrollSetup/Ori"));

const UpdatePayroll = lazy(() =>
  import("./app/dashboard/Pages/HR/PayrollSetup/UpdatePayroll")
);

const PayrollSetupView = lazy(() =>
  import("./app/dashboard/Pages/HR/PayrollSetup/PayrollSetupView")
);

const EmployeeSetUp = lazy(() =>
  import("./app/dashboard/Pages/HR/EmployeeSetUp/EmployeeSetUp")
);

const ExitRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/ExitRequisition/ExitRequisition")
);

const ExitRequisitionHOD = lazy(() =>
  import("./app/dashboard/Pages/Employee/ExitRequisition/ExitRequisitionHOD")
);
const ViewExitRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/ExitRequisition/ViewExitRequisition")
);
const AddExitRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/ExitRequisition/AddExitRequisition")
);

const AllExitRequisition = lazy(() =>
  import(
    "./app/dashboard/Pages/HR/ExitManagement/ExitRequisition/AllExitRequisition"
  )
);

const ViewExitRequisitions = lazy(() =>
  import(
    "./app/dashboard/Pages/HR/ExitManagement/ExitRequisition/ViewExitRequisition"
  )
);

const ExitDiscussionSetUp = lazy(() =>
  import(
    "./app/dashboard/Pages/HR/ExitManagement/ExitDiscussion/ExitDiscussionSetUp"
  )
);
const AddExitDiscussion = lazy(() =>
  import(
    `./app/dashboard/Pages/HR/ExitManagement/ExitDiscussion/AddExitDiscussion`
  )
);
const EditExitDiscussion = lazy(() =>
  import(
    `./app/dashboard/Pages/HR/ExitManagement/ExitDiscussion/EditExitDiscussion`
  )
);
const ExitDiscussion = lazy(() =>
  import(`./app/dashboard/Pages/Employee/ExitDiscussion/ExitDiscussion`)
);
const AddExitDisscussion = lazy(() =>
  import(`./app/dashboard/Pages/Employee/ExitDiscussion/AddDiscussion`)
);

const ViewExitDiscussion = lazy(() =>
  import(
    "./app/dashboard/Pages/HR/ExitManagement/ExitDiscussion/ViewExitDiscussion"
  )
);

const QuerySetup = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryManagementSetup/QuerySetup`)
);
const AddQuerySetup = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryManagementSetup/AddQuerySetup`)
);
const EditQuerySetup = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryManagementSetup/EditQuerySetup`)
);

const Query = lazy(() => import(`./app/dashboard/Pages/Employee/Query/Query`));
const QueryByHOD = lazy(() =>
  import(`./app/dashboard/Pages/Employee/Query/QueryByHOD`)
);
const QueryByHOC = lazy(() =>
  import(`./app/dashboard/Pages/Employee/Query/QueryByHOC`)
);
const MyQuery = lazy(() =>
  import(`./app/dashboard/Pages/Employee/Query/MyQuery`)
);
const AddQuery = lazy(() =>
  import(`./app/dashboard/Pages/Employee/Query/AddQuery`)
);
const EditQuery = lazy(() =>
  import(`./app/dashboard/Pages/Employee/Query/EditQuery`)
);
const ViewQuery = lazy(() =>
  import(`./app/dashboard/Pages/Employee/Query/ViewQuery`)
);

const AddQueryResponse = lazy(() =>
  import(`./app/dashboard/Pages/Employee/QueryResponse/AddQueryResponse`)
);

const QueryResponse = lazy(() =>
  import(`./app/dashboard/Pages/Employee/QueryResponse/QueryResponse`)
);

const ViewQueryResponse = lazy(() =>
  import(`./app/dashboard/Pages/Employee/QueryResponse/ViewQueryResponse`)
);
const MyQueryResponse = lazy(() =>
  import(`./app/dashboard/Pages/Employee/QueryResponse/MyQueryResponse`)
);
const QueryManagement = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryManagement/QueryManagement`)
);
const AddQueryManagement = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryManagement/AddQueryManagement`)
);
const EditQueryManagement = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryManagement/EditQueryManagement`)
);
const ViewQueryManagement = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryManagement/ViewQueryManagement`)
);

const AddQueryComments = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryManagement/AddQueryComments`)
);

const AddQueryPanel = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryManagement/AddQueryPanel`)
);

const OvertimeSetup = lazy(() =>
  import(`./app/dashboard/Pages/HR/OverTimeManagementSetup/OvertimeSetup`)
);

const WeekendAllowanceSetup = lazy(() =>
  import(
    `./app/dashboard/Pages/HR/WeekendAllowanceSetup/WeekendAllowanceSetup.js`
  )
);

const RepaymentPlanSetup = lazy(() =>
  import(`./app/dashboard/Pages/HR/RepaymentPlanSetup/RepaymentPlanSetup`)
);

const AuxiliaryServiceSetup = lazy(() =>
  import(`./app/dashboard/Pages/HR/AuxiliaryServiceSetup/AuxiliaryServiceSetup`)
);

const AuxiliaryServiceRequestApproval = lazy(() =>
  import(`./app/dashboard/Pages/HR/AuxiliaryServiceRequestApproval`)
);

const ViewAuxiliaryService = lazy(() =>
  import(`./app/dashboard/Pages/HR/AuxiliaryServiceSetup/ViewAuxiliaryService`)
);

const OvertimeManagement = lazy(() =>
  import(`./app/dashboard/Pages/HR/OvertimeManagement/OvertimeManagement`)
);

const QueryRequestApproval = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryRequestApproval`)
);

const ViewQueryRequestApproval = lazy(() =>
  import(
    `./app/dashboard/Pages/HR/QueryRequestApproval/ViewQueryRequestApproval`
  )
);

const QueryRequest = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryRequest`)
);

const AddQueryRequest = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryRequest/AddQueryRequest`)
);

const ViewQueryRequest = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryRequest/ViewQueryRequest`)
);

const UpdateQueryRequest = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryRequest/UpdateQueryRequest`)
);

const ViewOvertimeManagement = lazy(() =>
  import(`./app/dashboard/Pages/HR/OvertimeManagement/ViewOvertimeManagement`)
);

const OvertimeRequisition = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/OvertimeRequisition/OvertimeRequisition`
  )
);
const ViewOvertimeRequisition = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/OvertimeRequisition/ViewOvertimeRequisition`
  )
);

const AllQueryManagement = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryManagement/AllQueryManagement`)
);

const ViewAllQueryManagement = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryManagement/ViewAllQueryManagement`)
);
const EditQueryPanel = lazy(() =>
  import(`./app/dashboard/Pages/HR/QueryManagement/EditQueryPanel`)
);

const TabComponentHr = lazy(() =>
  import(`./app/dashboard/Pages/HR/EmployeeManagement/TabComponentHr`)
);

const EditEmployeeInformation = lazy(() =>
  import(
    `./app/dashboard/Pages/HR/EmployeeManagement/EmployeeInformation/EditEmployeeInformation`
  )
);

const NOKInformation = lazy(() =>
  import(`./app/dashboard/Pages/HR/EmployeeManagement/NOKUpdate/NOKInformation`)
);

const ViewNOKInformation = lazy(() =>
  import(`./app/dashboard/Pages/Employee/Employee/NOKUpdate/ViewNOKInformation`)
);

const MyEmployeeInfo = lazy(() =>
  import(`./app/dashboard/Pages/Employee/EmployeeInfo/MyEmployeeInfo`)
);

const EditMyEmployeeInformation = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeInfo/EditMyEmployeeInformation`
  )
);

const AddNewEmployee = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeInfo/CreateEmployeeInformation`
  )
);

const EditMyEmployeeInformationHr = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeInfo/EditMyEmployeeInformationHr`
  )
);

const ViewEmployeeInformationHr = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeInfo/ViewEmployeeInformationHr`
  )
);

const ViewNOKInformationHr = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/Employee/NOKUpdate/ViewNOKInformationHr`
  )
);

const ViewEmployeeInformation = lazy(() =>
  import(`./app/dashboard/Pages/Employee/EmployeeInfo/ViewEmployeeInformation`)
);
const AddMyNOK = lazy(() =>
  import(`./app/dashboard/Pages/Employee/Employee/NOKUpdate/AddMyNOK`)
);

const MyNOKInformation = lazy(() =>
  import(`./app/dashboard/Pages/Employee/Employee/NOKUpdate/MyNOKInformation`)
);

const EditMyNOKInformation = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/Employee/NOKUpdate/EditMyNOKInformation`
  )
);

const MyPayroll = lazy(() => import(`./app/dashboard/Pages/Employee/Payroll`));

const Medical = lazy(() => import(`./app/dashboard/Pages/HR/Medical`));

const MedicalServiceSetup = lazy(() =>
  import(`./app/dashboard/Pages/HR/Medical/MedicalServiceSetup`)
);

const AddNewHospital = lazy(() =>
  import(`./app/dashboard/Pages/HR/Medical/AddNewHospital`)
);

const ViewHospital = lazy(() =>
  import(`./app/dashboard/Pages/HR/Medical/HospitalDetails`)
);

const UpdateHospital = lazy(() =>
  import(`./app/dashboard/Pages/HR/Medical/UpdateHospital`)
);

const MedicalLimitSetup = lazy(() =>
  import(`./app/dashboard/Pages/HR/Medical/MedicalLimitSetup`)
);

const ViewMedicalLimit = lazy(() =>
  import(`./app/dashboard/Pages/HR/Medical/ViewMedicalLimit`)
);

const UpdateMedicalLimit = lazy(() =>
  import(`./app/dashboard/Pages/HR/Medical/UpdateMedicalLimit`)
);

const AddMedicalLimit = lazy(() =>
  import(`./app/dashboard/Pages/HR/Medical/AddMedicalLimit`)
);

const EmployeeMedicalLimit = lazy(() =>
  import(`./app/dashboard/Pages/HR/Medical/EmployeeMedicalLimit`)
);
const MyPayrollRun = lazy(() =>
  import(`./app/dashboard/Pages/Employee/Payroll/PayrollRun`)
);

const StaffRenumeration = lazy(() =>
  import(`./app/dashboard/Pages/Employee/Payroll/StaffRenumeration`)
);

const MyMedicalRequisition = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeMedicalRequisition/MyMedicallRequisition`
  )
);

const AddMyMedicalRequisition = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeMedicalRequisition/AddMyMedicalRequisition`
  )
);

const EditMyMedicalRequisition = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeMedicalRequisition/EditMyMedicalRequisition`
  )
);

const ViewMyMedicalRequisition = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeMedicalRequisition/ViewMyMedicalRequisition`
  )
);

const MedicalService = lazy(() =>
  import(`./app/dashboard/Pages/HR/MedicalService`)
);

const MedicalReport = lazy(() =>
  import(`./app/dashboard/Pages/HR/MedicalService/MedicalReport`)
);

const EmployeeQualification = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeQualification/EmployeeQualification`
  )
);

const EmployeeQualifications = lazy(() =>
  import(
    `./app/dashboard/Pages/HR/EmployeeManagement/EmployeeQualification/EmployeeQualifications`
  )
);

const AddEmployeeQualification = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeQualification/AddEmployeeQualification`
  )
);
const EditEmployeeQualification = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeQualification/EditEmployeeQualification`
  )
);
const ViewEmployeeQualification = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeQualification/ViewEmployeeQualification`
  )
);
const EmployeeReferee = lazy(() =>
  import(`./app/dashboard/Pages/Employee/EmployeeReferee/EmployeeReferee`)
);
const EmployeeReferees = lazy(() =>
  import(
    `./app/dashboard/Pages/HR/EmployeeManagement/EmployeeReferees/EmployeeReferees`
  )
);

const AddEmployeeReferee = lazy(() =>
  import(`./app/dashboard/Pages/Employee/EmployeeReferee/AddEmployeeReferee`)
);

const EditEmployeeReferee = lazy(() =>
  import(`./app/dashboard/Pages/Employee/EmployeeReferee/EditEmployeeReferee`)
);

const ViewEmployeeReferee = lazy(() =>
  import(`./app/dashboard/Pages/Employee/EmployeeReferee/ViewEmployeeReferee`)
);

const EditEmployeeExtendedClaim = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeExtendedClaim/EditEmployeeExtendedClaim`
  )
);

const AddEmployeeExtendedClaim = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeExtendedClaim/AddEmployeeExtendedClaim`
  )
);

const EmployeeExtendedClaim = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeExtendedClaim/EmployeeExtendedClaim`
  )
);

const ViewEmployeeExtendedClaim = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeExtendedClaim/ViewEmployeeExtendedClaim`
  )
);

const EmployeeExtendedClaims = lazy(() =>
  import(
    `./app/dashboard/Pages/HR/EmployeeManagement/EmployeeExtendedClaims/EmployeeExtendedClaims`
  )
);

const AllAuctionBidding = lazy(() =>
  import(
    `./app/dashboard/Pages/Employee/EmployeeAuctionBidding/AllAuctionBidding.js`
  )
);

const ViewBidding = lazy(() =>
  import(`./app/dashboard/Pages/Employee/EmployeeAuctionBidding/ViewBidding.js`)
);

const MemoRequisition = lazy(() => import("./app/dashboard/Pages/Memo"));
const EmployeeMemoRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/MemoRequisition")
);

const AddMemoRequisition = lazy(() =>
  import("./app/dashboard/Pages/Memo/AddRequisition")
);

const UpdateMemoRequisition = lazy(() =>
  import("./app/dashboard/Pages/Memo/AddRequisition")
);

const ViewMemoRequisition = lazy(() =>
  import("./app/dashboard/Pages/Memo/ViewRequisition")
);

const ViewEmployeeMemoRequisition = lazy(() =>
  import("./app/dashboard/Pages/Employee/MemoRequisition/ViewRequisition")
);

function Main() {
  const location = useLocation();
  const background = location?.state?.background;
  const userPermissions = getMyPermissions();
  const data = GetLocalStorage?.();
  const payrollAutoRun = useSelector(
    (state) => state?.payrollStore?.payrollAutoRun
  );
  useEffect(() => {
    if (payrollAutoRun === true) {
      toast.loading("Payroll is running on the background...", {
        closeButton: true,
        progress: false,
      });
    }
    if (payrollAutoRun === false) {
      toast.dismiss();
    }
  }, [payrollAutoRun]);
  return (
    <Suspense>
      <Routes location={background || location}>
        <Route path={URL.Home} element={<Home />} />
        <Route path={URL.ResetPassword} element={<ResetPassword />} />
        <Route element={<LoggedInRoute />}>
          <Route path={URL.Login} element={<Login />} />
          <Route path={URL.ForgotPassword} element={<ForgotPassword />} />
          <Route path={URL.SignUp} element={<SignUp />} />
          <Route path={URL.Email_Verified} element={<EmailConfirm />} />
        </Route>
        {/* JobPosting */}
        {/* <Route element={<JobPosting />}> */}
        <Route path={`/job-posting/:id`} element={<JobPosting />} />
        <Route path={`/job-application/:1d`} element={<JobApplicationForm />} />
        <Route path={`/job-offer/:id`} element={<ViewApplicantOffer />} />
        {/* </Route> */}
        <Route path={"/showcase"} element={<Showcase />} />
        {userPermissions.includes(DEFINED_PERMISSIONS.AssetView) && (
          <Route path={URL.Assets} element={<Assets />}>
            <Route path={URL.Acquisition} element={<Acquisition />} />
            <Route path={URL.Add_Acquitions} element={<AddAcquisition />} />
            <Route path={URL.View_Acquisition} element={<ViewAcquisition />} />
          </Route>
        )}
        <Route path={URL.Palliative} element={<Outlet />}>
          <Route index element={<Palliative />} />
        </Route>
        <Route element={<ProtectedRoutes />}>
          <Route path={URL.Onboarding} element={<Onboarding />} />
          <Route path={URL.Dashboard} element={<Dashboard />}>
            <Route index element={<DashboardHome />} />
            {/* {userPermissions.includes(DEFINED_PERMISSIONS.Vendor) && ( */}

            <Route path={URL.Management} element={<Management />}>
              <Route path={URL.Overtime_Management} element={<Outlet />}>
                <Route index element={<OvertimeManagement />} />
                <Route path={`:id/view`} element={<ViewOvertimeManagement />} />
              </Route>

              <Route path={URL.MANAGEMENT_APPRAISAL} element={<Outlet />}>
                <Route index element={<AppraisalReviewManagement />} />
                <Route
                  path={`:id/view`}
                  element={<ViewManagementAppraisal />}
                />
              </Route>

              <Route path={URL.APPRAISAL_REVIEW_MGT} element={<Outlet />}>
                <Route index element={<ManagementAppraisal />} />
                <Route
                  path={`:id/view`}
                  element={<ViewAppraisalManagementReview />}
                />
              </Route>

              <Route path={URL.Payment_Requisition} element={<Outlet />}>
                <Route index element={<PaymentRequisition />} />
                <Route
                  path={":id/edit"}
                  element={<UpdatePaymentRequisition />}
                />
                <Route
                  path={URL.Add_Payment_Requisition}
                  element={<AddPaymentRequisition />}
                />
                <Route
                  path={`:uuId/view`}
                  element={<ViewPaymentRequisition />}
                />
              </Route>

              <Route path={URL.Weekend_Allowance} element={<Outlet />}>
                <Route
                  path={URL.Weekend_Allowance_Hod}
                  element={<WeekendAllowanceForHod />}
                />
              </Route>

              <Route path={URL.Leave_HOD} element={<Outlet />}>
                <Route index element={<LeaveApprovalHOD />} />
              </Route>

              <Route path={URL.Exit_HOD} element={<Outlet />}>
                <Route index element={<ExitRequisitionHOD />} />
              </Route>

              <Route path={URL.Memo_Requisition} element={<Outlet />}>
                <Route index element={<MemoRequisition />} />
                <Route
                  path={URL.Add_Memo_Requisition}
                  element={<AddMemoRequisition />}
                />
                <Route path={":id/edit"} element={<UpdateMemoRequisition />} />
                <Route path={`:uuId/view`} element={<ViewMemoRequisition />} />
              </Route>

              <Route path={URL.Vendors} element={<Outlet />}>
                <Route index element={<EmployeeVendorsHome />} />
                <Route
                  path={`:id/${URL.View_Vendor}`}
                  element={<EmployeeViewVendor />}
                />
                {userPermissions.includes(DEFINED_PERMISSIONS.VendorCreate) && (
                  <>
                    <Route
                      path={URL.Add_Vendor}
                      element={<EmployeeAddVendor />}
                    />
                    <Route
                      path={URL.Create_Vendor}
                      element={<EmployeeCreateVendor />}
                    />
                  </>
                )}

                {userPermissions.includes(
                  DEFINED_PERMISSIONS.VendorManager
                ) && (
                  <>
                    <Route path={`:id/edit`} element={<EmployeeEditVendor />} />
                  </>
                )}

                <Route path=":id/appraise/:type" element={<AppraiseVendor />} />
              </Route>
            </Route>

            <Route path={URL.ControlReview} element={<ControlReview />}>
              <Route path={URL.Payment_Requisition} element={<Outlet />}>
                <Route index element={<PaymentRequisition />} />
                <Route
                  path={":id/edit"}
                  element={<UpdatePaymentRequisition />}
                />
                <Route
                  path={`:uuId/view`}
                  element={<ViewPaymentRequisition />}
                />
              </Route>
              <Route path={URL.Overtime_Management} element={<Outlet />}>
                <Route index element={<OvertimeManagement />} />
                <Route path={`:id/view`} element={<ViewOvertimeManagement />} />
              </Route>
              <Route path={URL.Weekend_Allowance} element={<Outlet />}>
                <Route index={true} element={<WeekendAllowanceForHod />} />
              </Route>
              <Route path={URL.Quotation_Management} element={<Outlet />}>
                <Route index={true} element={<ProcQuotationHome />} />
                <Route path={":id/view"} element={<ProcQuotationView />} />
                {/* ControlQuotationView */}
              </Route>
              {/* ControlQuotationHome */}
            </Route>

            <Route path={URL.EmployeeService} element={<EmployeeService />}>
              <Route
                path={URL.Weekend_Allowance_Hod}
                element={<WeekendAllowanceForHod />}
              />
              <Route path={URL.Overtime_Management} element={<Outlet />}>
                <Route index element={<OvertimeManagement />} />
                <Route path={`:id/view`} element={<ViewOvertimeManagement />} />
              </Route>

              <Route path={URL.Payment_Requisition} element={<Outlet />}>
                <Route index element={<PaymentRequisition />} />

                <Route
                  path={URL.Add_Payment_Requisition}
                  element={<AddPaymentRequisition />}
                />
                <Route
                  path={":id/edit"}
                  element={<UpdatePaymentRequisition />}
                />
                <Route
                  path={`:uuId/view`}
                  element={<ViewPaymentRequisition />}
                />
              </Route>

              <Route path={URL.Extended_HMO_Claims} element={<Outlet />}>
                <Route index element={<ExtendHMOClaims />} />

                <Route
                  path={URL.Add_Extended_HMO_Claims}
                  element={<AddExtendHMOClaims />}
                />
                <Route path={":id/edit"} element={<UpdateExtendHMOClaims />} />
                <Route path={`:id/view`} element={<ViewExtendHMOClaimss />} />
              </Route>
            </Route>

            <Route path={URL.Vendors} element={<VendorsMgt />}>
              <Route
                index
                element={
                  USER_CATEGORY.VENDOR === data?.category ? (
                    <ViewVendor />
                  ) : (
                    <VendorsHome />
                  )
                }
              />
              <Route path={`:id/${URL.View_Vendor}`} element={<ViewVendor />} />
              <Route path={URL.Add_Vendor} element={<AddVendor />} />
              <Route path={URL.Create_Vendor} element={<CreateVendor />} />

              {userPermissions.includes(DEFINED_PERMISSIONS.VendorManager) && (
                <Route path={`:id/edit`} element={<EditVendor />} />
              )}

              {userPermissions.includes(DEFINED_PERMISSIONS.VendorManager) && (
                <Route
                  path={`:id/:report/appraise/:type/:reporter/:reporter_department/:report_date`}
                  element={<AppraiseVendor />}
                />
              )}

              <Route path=":id/appraise/:type" element={<AppraiseVendor />} />
            </Route>

            <Route path={URL.Procurement} element={<Procurement />}>
              <Route index element={<Outlet />} />

              <Route path={URL.vendorPayment} element={<Outlet />}>
                <Route index element={<ViewVendorPayment />} />
              </Route>

              <Route
                path={URL.Quotation_Management}
                element={<Outlet action={() => console.log("lll")} />}
              >
                <Route index element={<ProcQuotationHome />} />
                <Route path={`:id/view`} element={<ProcQuotationView />} />
                {userPermissions.includes(DEFINED_PERMISSIONS.QuotationAdd) && (
                  <>
                    <Route
                      path={":id/:kind/add"}
                      element={<ProcQuotationAdd />}
                    />
                    <Route path={":id/edit"} element={<ProcQuotationAdd />} />
                  </>
                )}

                <Route
                  path=":id/delivery"
                  element={<ProcQuotationAddDeliveryNote />}
                />
              </Route>

              <Route path={URL.Maintenance} element={<Outlet />}>
                <Route index element={<AssetMaintenanceRequisitions />} />
                <Route
                  path={"add"}
                  element={<AddAssetMaintenanceRequisition />}
                />
                <Route
                  path={":id/edit"}
                  element={<EditAssetMaintenanceRequisition />}
                />
                <Route
                  path={`:id/view`}
                  element={<ViewAssetMaintenanceRequisition />}
                />
              </Route>

              <Route path={URL.Requisition_Management} element={<Outlet />}>
                <Route index element={<ProcRequisitionHome />} />
                {userPermissions.includes(
                  DEFINED_PERMISSIONS.ProcurementRequisitionDashboard
                ) && (
                  <>
                    <Route path={"add"} element={<ProcRequisitionAdd />} />
                    <Route path={":id/edit"} element={<ProcRequisitionAdd />} />
                  </>
                )}
                {userPermissions.includes(
                  DEFINED_PERMISSIONS.ProcurementRequisitionView
                ) && (
                  <Route path={`:id/view`} element={<ProcRequisitionView />} />
                )}
              </Route>

              <Route path={URL.Waiver_Management} element={<Outlet />}>
                <Route index element={<ProcRequisitionWaivers />} />
                {userPermissions.includes(
                  DEFINED_PERMISSIONS.ProcurementRequisitionDashboard
                ) && (
                  <>
                    {/* <Route path={"add"} element={<ProcRequisitionAdd />} /> */}
                    {/* <Route path={":id/edit"} element={<ProcRequisitionAdd />} /> */}
                  </>
                )}
                {userPermissions.includes(
                  DEFINED_PERMISSIONS.ProcurementRequisitionView
                ) && (
                  <Route
                    path={`:id/view`}
                    element={<ProcRequisitionWaiverView />}
                  />
                )}
              </Route>

              {userPermissions.includes(DEFINED_PERMISSIONS.DeliveryView) && (
                <>
                  <Route path={URL.Delivery} element={<Outlet />}>
                    <Route index element={<ProcDeliveryHome />} />
                    <Route
                      path={`:id/view`}
                      element={<ProcQuotationDeliveryView />}
                    />
                    {userPermissions.includes(
                      DEFINED_PERMISSIONS.DeliveryView
                    ) && (
                      <>
                        <Route path={"add"} element={<ProcRequisitionAdd />} />
                        <Route
                          path={":id/edit"}
                          element={<ProcRequisitionAdd />}
                        />
                      </>
                    )}

                    {userPermissions.includes(
                      DEFINED_PERMISSIONS.DeliveryView
                    ) && (
                      <Route
                        path={`:id/view`}
                        element={<ProcRequisitionView />}
                      />
                    )}
                  </Route>
                  <>
                    <Route path={`:id/edit`} element={<EditVendor />} />
                    <Route
                      path={`:id/appraise/:type`}
                      element={<AppraiseVendor />}
                    />
                  </>
                </>
              )}
            </Route>

            {userPermissions.includes(DEFINED_PERMISSIONS.ConsumableView) && (
              <Route path={URL.Consumables} element={<Procurement />}>
                <Route index element={<Outlet />} />
                <Route
                  path={URL.Consumable_Acqusition}
                  element={<Outlet action={() => console.log("lll")} />}
                >
                  <Route index element={<ConsumableAcquisition />} />
                  {userPermissions.includes(
                    DEFINED_PERMISSIONS.ConsumableAdd
                  ) && (
                    <Route
                      path={"add"}
                      element={<AddConsumableAcquisition />}
                    />
                  )}
                  <Route
                    path={`:id/view`}
                    element={<ViewConsumableAcquisition />}
                  />
                </Route>

                {userPermissions.includes(
                  DEFINED_PERMISSIONS.ConsumableAllocationView
                ) && (
                  <Route path={URL.Consumable_Allocation} element={<Outlet />}>
                    <Route index element={<ConsumableAllocation />} />
                    {userPermissions.includes(
                      DEFINED_PERMISSIONS.ConsumableAllocationAdd
                    ) && (
                      <Route
                        path={"add"}
                        element={<AddConsumableAllocation />}
                      />
                    )}
                    {userPermissions.includes(
                      DEFINED_PERMISSIONS.ConsumableAllocationView
                    ) && (
                      <Route
                        path={`:id/view`}
                        element={<ViewConsumableAllocation />}
                      />
                    )}
                  </Route>
                )}
                {userPermissions.includes(
                  DEFINED_PERMISSIONS.ConsumableRequisitionView
                ) && (
                  <Route path={URL.Consumable_Requsition} element={<Outlet />}>
                    <Route index element={<ConsumableRequisition />} />
                    {userPermissions.includes(
                      DEFINED_PERMISSIONS.ConsumableRequisitionAdd
                    ) && (
                      <Route
                        path={"add"}
                        element={<AddConsumableRequisition />}
                      />
                    )}
                    <Route
                      path={`:id/view`}
                      element={<ViewConsumableRequisition />}
                    />
                  </Route>
                )}
              </Route>
            )}
            {userPermissions.includes(DEFINED_PERMISSIONS.AssetView) && (
              <Route path={URL.AssetSetUp} element={<Procurement />}>
                <Route index element={<Outlet />} />
                <Route
                  path={URL.AssetRegister}
                  element={<Outlet action={() => console.log("lll")} />}
                >
                  <Route index element={<AssetRegister />} />
                  <Route path={"add"} element={<AddAssetRegister />} />
                  <Route path={`:id/view`} element={<ViewAssetRegister />} />
                  <Route path={`:id/edit`} element={<EditAssetRegister />} />
                </Route>
                {userPermissions.includes(
                  DEFINED_PERMISSIONS.AssetCategoryView
                ) && (
                  <Route path={URL.Categories} element={<Outlet />}>
                    <Route index element={<Categories />} />
                    {userPermissions.includes(
                      DEFINED_PERMISSIONS.AssetCategoryAdd
                    ) && <Route path={"add"} element={<AddCategories />} />}
                    <Route path={`:id/view`} element={<ViewCategories />} />
                  </Route>
                )}

                <Route path={URL.Budget} element={<Budget />} />
              </Route>
            )}
            <Route path={URL.ConsummableSetUp} element={<Procurement />}>
              <Route index element={<Outlet />} />
              {userPermissions.includes(DEFINED_PERMISSIONS.ConsumableView) && (
                <Route
                  path={URL.ConsummbaleRegister}
                  element={<Outlet action={() => console.log("lll")} />}
                >
                  <Route index element={<ConsummablesRegister />} />
                  <Route path={"add"} element={<AddConsummablesRegister />} />
                  <Route
                    path={`:id/view`}
                    element={<ViewConsummablesRegister />}
                  />
                  <Route
                    path={`:id/edit`}
                    element={<EditConsummablesRegister />}
                  />
                </Route>
              )}

              {userPermissions.includes(
                DEFINED_PERMISSIONS.ConsumableCategoryView
              ) && (
                <Route path={URL.ConsummableCategories} element={<Outlet />}>
                  <Route index element={<ConsummablesCategories />} />
                  <Route path={"add"} element={<AddConsummablesCategories />} />
                  <Route
                    path={`:id/view`}
                    element={<ViewConsummablesCategories />}
                  />
                </Route>
              )}

              <Route path={URL.Budget} element={<Budget />} />
            </Route>

            {/* <Route path={URL.Procurement} element={<p>Procurement</p>} /> */}
            {/* {userPermissions.includes(DEFINED_PERMISSIONS.AssetManager) && ( */}
            <Route path={URL.Assets} element={<Assets />}>
              <Route index element={<Acquisition />} />
              <Route path={URL.Acquisition} element={<Outlet />}>
                <Route index element={<Acquisition />} />
                <Route path={URL.Add_Acquitions} element={<AddAcquisition />} />
                <Route
                  path={`:id/${URL.View_Acquisition}`}
                  element={<ViewAcquisition />}
                />
              </Route>
              <Route path={URL.Allocation} element={<Outlet />}>
                <Route index element={<Allocation />} />
                <Route path={"add"} element={<AddAllocation />} />
                <Route path={`:id/view`} element={<ViewAllocation />} />
              </Route>
              <Route path={URL.Requisition} element={<Outlet />}>
                <Route index element={<AssetRequisition />} />
                <Route path={"add"} element={<AddRequisition />} />
                <Route path={`:id/view`} element={<ViewAssetRequisition />} />
              </Route>
              <Route path={URL.Monitoring} element={<Outlet />}>
                <Route index element={<Monitoring />} />
                <Route path={"add"} element={<AddMonitoring />} />
                <Route path={`:id/view`} element={<ViewMonitoring />} />
              </Route>
              <Route path={URL.Auctioning} element={<Outlet />}>
                <Route index element={<Auctioning />} />
                <Route path={"add"} element={<AddAuctioning />} />
                <Route path={`:id/view`} element={<ViewAuctioning />} />
              </Route>
              <Route path={URL.AuctionBidding} element={<Outlet />}>
                <Route index element={<AuctioningBidding />} />
                <Route path={"add"} element={<AddAuctioning />} />
                <Route path={`:id/view`} element={<ViewAuctioningBidding />} />
              </Route>
            </Route>
            {/* )} */}
            <Route path={URL.Fleets} element={<Fleet />}>
              <Route index element={<Outlet />} />
              <Route path={URL.Generate_Report} element={<GenerateReports />} />
              <Route path={URL.Fleet_Management} element={<Outlet />}>
                <Route index element={<Fleets />} />
                <Route path={`:id/view`} element={<ViewFleet />} />
              </Route>
              <Route path={URL.Requisition} element={<Outlet />}>
                <Route index element={<Requisition />} />
                <Route
                  path={URL.Add_Requisitions}
                  element={<AddFuelRequisition />}
                />
                <Route path={`:id/edit`} element={<EditRequisition />} />
                <Route path={`:id/view`} element={<ViewRequisition />} />
                <Route
                  path={URL.My_Requisitions}
                  element={<MyRequisitions />}
                />
              </Route>
              <Route path={URL.Fuel_Payment} element={<Outlet />}>
                <Route index element={<FuelPayment />} />
                <Route path={"add"} element={<AddFuelPayment />} />
                <Route path={`:id/edit`} element={<EditPayment />} />
                <Route path={`:id/view`} element={<ViewPayment />} />
                <Route path={URL.My_Payment} element={<MyPayment />} />
              </Route>
              <Route path={URL.Driver_Activity} element={<Outlet />}>
                <Route index element={<DriverActivity />} />
                <Route path={"add"} element={<AddActivity />} />
                <Route path={`:id/edit`} element={<EditActivity />} />
                <Route path={`:id/view`} element={<ViewDriverActivity />} />
                <Route
                  path={URL.All_DriverActivity}
                  element={<AllDriverActivities />}
                />
                <Route path={URL.Scheduler} element={<Scheduler />} />
              </Route>
              <Route path={URL.Movement} element={<Outlet />}>
                <Route index element={<FleetMovementSummary />} />
                <Route
                  path={`:id/view`}
                  element={<FleetMovementSummaryDetails />}
                />
                {/* <Route path={"add"} element={<AddActivity />} /> */}
                {/* <Route path={`:id/edit`} element={<EditActivity />} /> */}
              </Route>
              <Route path={URL.Vehicle_Maintenance} element={<Outlet />}>
                <Route index element={<VehicleMaintenance />} />
                <Route
                  path={"add"}
                  element={<VehicleMaintenanceRequsition />}
                />
                <Route
                  path={":id/edit"}
                  element={<EditVehicleMaintenanceRequsition />}
                />
                <Route
                  path={`:id/view`}
                  element={<ViewMaintenanceRequisition />}
                />
              </Route>
              <Route path={URL.Accident_Report} element={<Outlet />}>
                <Route index element={<AccidentReport />} />
                <Route path={"add"} element={<AddAccidentReport />} />
                <Route path={":id/edit"} element={<EditAccidentReport />} />
                <Route path={`:id/view`} element={<ViewAccidentReport />} />
              </Route>

              <Route path={URL.Vehicle_Document_SetUp} element={<Outlet />}>
                <Route index element={<DocumentSetup />} />
              </Route>
            </Route>

            <Route path={URL.Reports} element={<Outlet />}>
              <Route path={URL.Report_configuration} element={<Outlet />}>
                <Route index element={<ReportIndex />} />
                <Route path={"add"} element={<ReportsAdd />} />
                <Route
                  path={"edit/:id"}
                  element={<ReportsAdd isEdit={true} />}
                />
              </Route>
              <Route
                path={URL.Trigger_History}
                element={<ReportTriggerHistory />}
              />

              {/* <Route path={URL.Report_scheduler} element={<Outlet/>}>
                  <Route index element={<ReportScheduler/>}/>
                  <Route path={"add"} element={<AddReportScheduler/>}/>
                </Route> */}
              <Route path={URL.Generate_Report} element={<GenerateReports />} />

              {/* <Route path={URL.Report_configuration} element={<Outlet/>}>
                    <Route index element={<ReportConfiguration/>}/>
                    <Route path={"add"} element={<ReportConfigurationAdd/>}/>
                    <Route
                        path={":id"}
                        element={<ReportConfigurationDetails/>}
                    />
                  </Route> */}
            </Route>

            <Route path={URL.Inventory} element={<p>Inventory</p>} />

            <Route path={URL.HR} element={<HR />}>
              <Route index element={<Outlet />} />
              {/* dashboard/hr/Employee-Management/update */}
              {/* ViewEmployeeInformationHr */}
              <Route
                path={"Employee-Management/:id/view"}
                element={<ViewEmployeeInformationHr />}
              />
              <Route
                path={`Employee-Management/update/:id`}
                element={<EditMyEmployeeInformationHr />}
              />
              <Route
                path={`Employee-Management/view-nok/:id`}
                element={<ViewNOKInformationHr />}
              />
              <Route path={URL.Training_Request} element={<Outlet />}>
                <Route index element={<TrainingRequisitions />} />
                <Route
                  path={`:id/view`}
                  element={<ViewTrainingRequisition />}
                />
              </Route>
              <Route path={URL.Training_SetUp} element={<Outlet />}>
                <Route index element={<TrainingSetup />} />
              </Route>

              <Route path={URL.Employee_Setup} element={<Outlet />}>
                <Route index element={<EmployeeSetUp />} />
              </Route>
              <Route path={URL.Appraisal_Setup} element={<Outlet />}>
                <Route index element={<HRAppraisalSetup />} />
                <Route path={URL.PIP} element={<Outlet />}>
                  <Route index element={<PerformanceImprovementPlan />} />
                  <Route path={`:id/view`} element={<Outlet />}>
                    <Route index element={<ViewPIP />} />
                    <Route
                      path={`:id/view-pip`}
                      element={<ViewSingleMainPIP />}
                    />
                  </Route>
                </Route>
                <Route path={URL.Development_Plan} element={<Outlet />}>
                  <Route index element={<DevelopmentPlan />} />
                  <Route path={`:id/view`} element={<ViewDevelopmentPlan />} />
                </Route>
                <Route
                  path={URL.Expected_Improvement_Plan}
                  element={<Outlet />}
                >
                  <Route index element={<ExpectedImprovementPlan />} />
                  <Route
                    path={`:id/view`}
                    element={<ViewExpectedImprovementPlan />}
                  />
                </Route>
                <Route
                  path={URL.Appraisal_Manage_Objectives}
                  element={<Outlet />}
                >
                  <Route index element={<CreateObjectives />} />
                  <Route
                    path={URL.View_Appraisal_Objectives}
                    element={<ViewAppraisalObjective />}
                  />
                </Route>

                <Route path={URL.Key_Result_Area} element={<Outlet />}>
                  <Route index element={<KeyResultArea />} />
                  <Route
                    path={URL.View_Key_Result_Area}
                    element={<ViewKeyResultArea />}
                  />
                </Route>

                <Route path={URL.Appraisal_Period} element={<Outlet />}>
                  <Route index element={<AppraisalPeriod />} />
                  <Route
                    path={URL.VIEW_APPRAISAL_PERIOD}
                    element={<ViewAppraisalPeriod />}
                  />
                </Route>

                <Route path={URL.Rating_Scale} element={<Outlet />}>
                  <Route index element={<RatingScale />} />
                  <Route
                    path={URL.VIEW_RATING_SCALE}
                    element={<ViewSingleRatingScale />}
                  />
                </Route>
                <Route
                  path={URL.Score_Base_Recommendations}
                  element={<Outlet />}
                >
                  <Route index element={<ScoreRecommendation />} />
                  <Route
                    path={URL.View_Score_Base_recommendation}
                    element={<ViewScoreBased />}
                  />
                </Route>
                <Route path={URL.Performance_StatusLabel} element={<Outlet />}>
                  <Route index element={<StatusLabel />} />
                  <Route
                    path={URL.VIEW_PERFORMANCE_STATUS_LABEL}
                    element={<ViewStatusLabel />}
                  />
                </Route>
                <Route path={URL.Counselling_type} element={<Outlet />}>
                  <Route index element={<CounselingType />} />
                  <Route
                    path={URL.Single_Counselling_Type}
                    element={<ViewCounsellingType />}
                  />
                </Route>
                <Route path={URL.CommitteeList} element={<Outlet />}>
                  <Route index element={<CommitteeList />} />
                  <Route path={`:id/view`} element={<CommitteeListView />} />
                </Route>
              </Route>
              <Route path={URL.Appraisal_HR} element={<Outlet />}>
                <Route index element={<HRAppraisal />} />
                <Route path={`:id/view`} element={<ViewHRAppraisal />} />
              </Route>
              <Route path={URL.Medical} element={<Outlet />}>
                <Route index element={<Medical />} />
                <Route path={URL.Medical_Service_Setup} element={<Outlet />}>
                  <Route index element={<MedicalServiceSetup />} />
                  <Route path={`:id/view`} element={<ViewHospital />} />
                  <Route path={":id/edit"} element={<UpdateHospital />} />
                </Route>

                <Route path={URL.Medical_Limit_Setup} element={<Outlet />}>
                  <Route index element={<MedicalLimitSetup />} />
                  <Route path={`:id/view`} element={<ViewMedicalLimit />} />
                  <Route path={":id/edit"} element={<UpdateMedicalLimit />} />
                </Route>

                <Route
                  path={URL.Add_Medical_Limit_Setup}
                  element={<AddMedicalLimit />}
                />

                <Route
                  path={URL.Add_New_Hospital}
                  element={<AddNewHospital />}
                />
                <Route
                  path={URL.Employee_Medical_Limit}
                  element={<EmployeeMedicalLimit />}
                />
              </Route>

              <Route path={URL.Medical_Service} element={<Outlet />}>
                <Route index element={<MedicalService />} />
                <Route path={URL.Medical_Report} element={<MedicalReport />} />
              </Route>

              {/* FROM HERE */}
              <Route path={""} element={<Outlet />}>
                <Route
                  path={URL.General_Recruitment_Setup}
                  element={<GeneralSetup />}
                />

                <Route path={URL.Recruitment_Setup} element={<Outlet />}>
                  <Route index element={<RecruitmentSetUp />} />
                  <Route path={`:id/view`} element={<JobTitleDetails />} />
                  <Route path={":id/edit"} element={<JobTitleUpdate />} />

                  <Route
                    path={URL.Application_Channel_Setup}
                    element={<ApplicationChannelSetup />}
                  />

                  <Route
                    path={URL.Setup_Application_Channel}
                    element={<SetApplicationChannel />}
                  />
                  <Route
                    path={`:id/view`}
                    element={<ApplicationChannelDetails />}
                  />

                  <Route
                    path={URL.Setup_Jobtitle}
                    element={<SetupJobtitle />}
                  />
                </Route>

                <Route path={URL.JobList_Setup} element={<Outlet />}>
                  <Route index element={<JobListSetup />} />
                  {/* <Route path={URL.Set_Skills} element={<SetSkills />} /> */}
                  {/* Setup_JobList */}
                  <Route
                    path={URL.Setup_JobList}
                    element={<SetupJoblisting />}
                  />
                  <Route path={`:id/view`} element={<JobListingDetails />} />
                  <Route path={":id/edit"} element={<SkillsUpdate />} />
                </Route>

                <Route path={URL.Set_Skills} element={<Outlet />}>
                  <Route index element={<SetSkills />} />
                  {/* <Route path={URL.Set_Skills} element={<SetSkills />} /> */}
                  <Route path={URL.Set_Up_Skills} element={<SetUpSkills />} />
                  <Route path={`:id/view`} element={<SkillsDetails />} />
                  <Route path={":id/edit"} element={<SkillsUpdate />} />
                </Route>

                <Route path={URL.Qualification_Setup} element={<Outlet />}>
                  <Route index element={<QualificationSetup />} />

                  <Route
                    path={URL.Setup_Qualification}
                    element={<SetupQualification />}
                  />
                  <Route path={`:id/view`} element={<QualificationDetails />} />
                  <Route path={":id/edit"} element={<QualificationUpdate />} />
                </Route>

                <Route path={URL.Metrics_Setup} element={<Outlet />}>
                  <Route index element={<MetricsSetup />} />

                  <Route path={URL.Setup_Metrics} element={<SetupMetrics />} />
                  <Route path={`:id/view`} element={<MetricsDetails />} />
                  <Route path={":id/edit"} element={<MetricsUpdate />} />
                </Route>
              </Route>
              {/* FROM HERE */}

              <Route path={URL.Application_Channel_Setup} element={<Outlet />}>
                <Route index element={<ApplicationChannelSetup />} />

                <Route
                  path={URL.Setup_Application_Channel}
                  element={<SetApplicationChannel />}
                />
                <Route
                  path={`:id/view`}
                  element={<ApplicationChannelDetails />}
                />
                <Route path={":id/edit"} element={<ApplicationUpdate />} />
              </Route>

              <Route path={URL.Recruitment_Service} element={<Outlet />}>
                <Route index element={<MyRecruitmentSetUp />} />

                <Route path={URL.Add_Applicant} element={<AddApplicant />} />
                <Route path={`:id/view`} element={<ViewApplicant />} />
                <Route path={":id/edit"} element={<UpdateApplicant />} />
                <Route
                  path={URL.Signin_Applicant}
                  element={<SigninApplicant />}
                />

                <Route
                  path={URL.Initiate_Recruitment}
                  element={<MyInitiateRecruitment />}
                />
                <Route
                  path={URL.Recruitment_Details}
                  element={<RecruitmentDetails />}
                />
                <Route
                  path={URL.Recruitment_Process_Review}
                  element={<RecruitmentProcess />}
                />
                <Route
                  path={URL.Recruitment_Process}
                  element={<RecruitmentProcessOverview />}
                />

                <Route
                  path={URL.Recruitment_Process_Ed}
                  element={<RecruitmentProcessOverviewEd />}
                />

                <Route
                  path={URL.Recruitment_Process_Md}
                  element={<RecruitmentProcessOverviewMd />}
                />

                <Route
                  path={URL.Initiate_Recruitment}
                  element={<InitiateRecruitment />}
                />
                <Route
                  path={`${URL.Update_Recruitment}/:id`}
                  element={<UpdateRecruitment />}
                />
                <Route
                  path={`${URL.Recruitment_Process_Details}/:id`}
                  element={<RecruitmentProcessDetails />}
                />
                <Route
                  path={`${URL.Recruitment_Review_Group}/:id`}
                  element={<RecruitmentReviewGroup />}
                />
                <Route
                  path={URL.Recruitment_Review_Details}
                  element={<RecruitmentReviewDetails />}
                />
                <Route
                  path={URL.Recruitment_Comment}
                  element={<RecruitmentComment />}
                />
                <Route
                  path={URL.Schedule_Interview}
                  element={<ScheduleInterview />}
                />
                <Route
                  path={URL.Job_Application}
                  element={<JobApplication />}
                />
                <Route
                  path={`${URL.Upload_Medical_Form}/:id`}
                  element={<UploadMedicalForm />}
                />
              </Route>

              <Route path={URL.Attendance_Clock} element={<Outlet />}>
                <Route index element={<AttendanceClock />} />
                <Route path={URL.Clock_Setting} element={<ClockSetting />} />
                <Route
                  // path={URL.Update_Clock} element={<UpdateClock />}
                  path={":id/edit"}
                  element={<UpdateClock />}
                />
                <Route path={URL.Clock_Setup} element={<ClockSetup />} />
              </Route>

              <Route path={URL.Employee_Group} element={<Outlet />}>
                <Route index element={<EmployeeGroup />} />
                <Route
                  path={URL.Add_Employee_Group}
                  element={<AddEmployeeGroup />}
                />
                <Route path={":id/edit"} element={<UpdateEmployeeGroup />} />

                <Route path={`:id/view`} element={<ViewEmployeeGroup />} />
              </Route>

              <Route path={URL.Loan_Setup} element={<Outlet />}>
                <Route index element={<LoanSetup />} />

                <Route path={URL.Add_Loan_Setup} element={<AddLoan />} />
                <Route path={":id/edit"} element={<UpdateLoan />} />
              </Route>

              <Route path={URL.Loan_Requisition} element={<Outlet />}>
                <Route index element={<LoanRequisition />} />

                <Route
                  path={URL.Add_Loan_Requisition}
                  element={<AddLoanRequisition />}
                />
                <Route path={":id/edit"} element={<UpdateLoanRequisition />} />
                <Route path={`:id/view`} element={<ViewLoanRequisition />} />
              </Route>

              <Route path={URL.Loan_Rule_Setup} element={<Outlet />}>
                <Route index element={<LoanRuleSetup />} />

                <Route
                  path={URL.Add_Loan_Rule_Setup}
                  element={<AddLoanRule />}
                />
                <Route path={":id/edit"} element={<UpdateLoanRule />} />
              </Route>

              {/* <Route path={URL.Employee_Medical_Requisition} element={<Outlet />}>
                  <Route index element={<EmployeeMedicalRequisition />} />
                  
                  <Route path={URL.Add_Employee_Medical_Requisition} element={<AddMedicalRequisition />} />
                  <Route
                    path={":id/edit"}
                    element={<UpdateMedicalRequisition />}
                  />
                  <Route path={`:id/view`} 
                  element={<ViewMedicalRequisition />} 
                  />

                </Route> */}

              <Route path={URL.Directorate} element={<Outlet />}>
                <Route index element={<Directorate />} />

                <Route
                  path={URL.Add_Directorate}
                  element={<AddDirectorate />}
                />
                <Route path={":id/edit"} element={<UpdateDirectorate />} />
                <Route path={`:id/view`} element={<ViewDirectorate />} />
              </Route>

              {/* <Route path={URL.Payment_Requisition} element={<Outlet />}>
                <Route index element={<PaymentRequisition />} />

                <Route
                  path={URL.Add_Payment_Requisition}
                  element={<AddPaymentRequisition />}
                />
                <Route
                  path={":id/edit"}
                  element={<UpdatePaymentRequisition />}
                />
                <Route
                  path={`:uuId/view`}
                  element={<ViewPaymentRequisition />}
                />
              </Route> */}

              <Route path={URL.Employee_Cadre_Position} element={<Outlet />}>
                <Route index element={<EmployeeCadrePosition />} />
                <Route
                  path={URL.Add_Employee_Cadre_Position}
                  element={<AddEmployeeCadrePosition />}
                />
                <Route
                  path={":id/edit"}
                  element={<UpdateEmployeeCadrePosition />}
                />
                <Route
                  path={`:id/view`}
                  element={<ViewEmployeeCadrePosition />}
                />
              </Route>

              <Route
                path={URL.Employee_Cadre_Position_Level}
                element={<Outlet />}
              >
                <Route index element={<EmployeeCadrePositionLevel />} />
                <Route
                  path={URL.Add_Employee_Cadre_Position_Level}
                  element={<AddEmployeeCadrePositionLevel />}
                />
                <Route
                  path={":id/edit"}
                  element={<UpdateEmployeeCadrePositionLevel />}
                />
                <Route
                  path={`:id/view`}
                  element={<ViewEmployeeCadrePositionLevel />}
                />
              </Route>

              <Route path={URL.Payroll_Structure} element={<Outlet />}>
                <Route index element={<PayrollStructure />} />
                <Route
                  path={URL.Add_Payroll_Structure}
                  element={<AddPayrollStructure />}
                />
                <Route path={":id/edit"} element={<UpdatePayrollStructure />} />

                <Route path={`:id/view`} element={<ViewPayrollStructure />} />
              </Route>

              <Route path={URL.Payroll_Setup} element={<Outlet />}>
                <Route index element={<PayrollSetup />} />
                <Route path={URL.Add_Payroll_items} element={<AddPayroll />} />
                <Route
                  path={URL.Payroll_ComponentTable}
                  element={<PayrollComponentTable />}
                />
                <Route path={URL.PayTest} element={<PayTest />} />
                <Route path={URL.PayTester} element={<PayTester />} />
                <Route path={URL.Ori} element={<Ori />} />
                <Route path={":id/edit"} element={<UpdatePayroll />} />
                <Route path={`:id/view`} element={<PayrollSetupView />} />
              </Route>

              <Route index element={<LeaveRequisition />} />

              <Route path={URL.Leave_Approval} element={<Outlet />}>
                <Route index element={<LeaveApproval />} />
              </Route>
              <Route path={URL.Leave_HOD} element={<Outlet />}>
                <Route index element={<LeaveApprovalHOD />} />
              </Route>
              <Route path={URL.Leave_SetUp} element={<Outlet />}>
                <Route index element={<LeaveSetUp />} />
                {/* <Route path={"add"} element={<AddSetUp />} /> */}
              </Route>
              <Route path={URL.Exit_Management} element={<Outlet />}>
                <Route index element={<AllExitRequisition />} />
                <Route path={`:id/view`} element={<ViewExitRequisitions />} />
              </Route>

              <Route path={URL.Exit_Discussion_SetUp} element={<Outlet />}>
                <Route index element={<ExitDiscussionSetUp />} />
                <Route path={"add"} element={<AddExitDiscussion />} />
                <Route path={":id/edit"} element={<EditExitDiscussion />} />
              </Route>
              <Route path={URL.Query_SetUp} element={<Outlet />}>
                <Route index element={<QuerySetup />} />
                <Route path={"add"} element={<AddQuerySetup />} />
                <Route path={":id/edit"} element={<EditQuerySetup />} />
              </Route>
              <Route path={URL.Query_Management} element={<Outlet />}>
                <Route index element={<QueryManagement />} />
                <Route path={"add"} element={<AddQueryManagement />} />
                <Route path={":id/edit"} element={<EditQueryManagement />} />
                <Route path={`:id/view`} element={<ViewQueryManagement />} />
                <Route path={`:id/add-panel`} element={<AddQueryPanel />} />
                <Route
                  path={`:id/add-comment`}
                  element={<AddQueryComments />}
                />
                <Route path={":id/editPanel"} element={<EditQueryPanel />} />
                <Route
                  path={":id/viewpanel"}
                  element={<ViewAllQueryManagement />}
                />

                <Route
                  path={URL.All_Query_Management}
                  element={<AllQueryManagement />}
                />
              </Route>
              <Route path={URL.Overtime_Setup} element={<Outlet />}>
                <Route index element={<OvertimeSetup />} />
              </Route>
              {/* WeekendAllowanceSetup */}
              <Route path={URL.Weekend_Allowance_Setup} element={<Outlet />}>
                <Route index element={<WeekendAllowanceSetup />} />
              </Route>

              {/* AuxiliaryServiceSetup */}
              <Route path={URL.Auxiliary_Service_Setup} element={<Outlet />}>
                <Route index element={<AuxiliaryServiceSetup />} />
                <Route path={`:id/view`} element={<ViewAuxiliaryService />} />
              </Route>

              {/* QueryRequest */}
              <Route path={URL.query_request} element={<Outlet />}>
                <Route index element={<QueryRequest />} />

                <Route
                  path={URL.add_query_request}
                  element={<AddQueryRequest />}
                />
                <Route path={":id/edit"} element={<UpdateQueryRequest />} />
                <Route path={`:id/view`} element={<ViewQueryRequest />} />
              </Route>

              {/* QueryRequestApproval */}
              <Route path={URL.query_approval} element={<Outlet />}>
                <Route index element={<QueryRequestApproval />} />
                <Route
                  path={`:id/view`}
                  element={<ViewQueryRequestApproval />}
                />
              </Route>

              {/* RepaymentPlanSetup */}
              <Route path={URL.Repayment_Plan_Setup} element={<Outlet />}>
                <Route index element={<RepaymentPlanSetup />} />
                <Route path={`:id/view`} element={<ViewRepaymentPlanSetup />} />
              </Route>

              <Route path={URL.Auxiliary_Service_Approval} element={<Outlet />}>
                <Route index element={<AuxiliaryServiceRequestApproval />} />

                {/* <Route
                  path={URL.add_auxiliary_service_request}
                  element={<AddAuxiliaryRequest />}
                /> */}
                {/* <Route
                  path={":id/edit"}
                  element={<UpdateAuxiliaryRequest />}
                /> */}
                <Route path={`:id/view`} element={<ViewAuxiliaryRequest />} />
              </Route>

              <Route path={URL.Overtime_Management} element={<Outlet />}>
                <Route index element={<OvertimeManagement />} />
                <Route path={`:id/view`} element={<ViewOvertimeManagement />} />
              </Route>
              <Route path={URL.Employee_Management} element={<Outlet />}>
                {/* <Route index element={<AllEmployees />} /> */}
                <Route index element={<TabComponentHr />} />
                <Route
                  path={`:id/edit`}
                  element={<EditEmployeeInformation />}
                />
                <Route
                  path={URL.NOK_Information}
                  element={<NOKInformation />}
                ></Route>
                <Route
                  path={URL.Medical_Requisition}
                  element={<MedicalRequisition />}
                ></Route>

                <Route
                  path={URL.Employee_Qualifications}
                  element={<EmployeeQualifications />}
                ></Route>

                <Route
                  path={URL.Employee_Claims}
                  element={<EmployeeExtendedClaims />}
                ></Route>
                <Route
                  path={URL.Employee_Refs}
                  element={<EmployeeReferees />}
                ></Route>
              </Route>
            </Route>

            <Route path={URL.Employee} element={<Employee />}>
              <Route path={URL.Payment_Requisition} element={<Outlet />}>
                <Route index element={<EmployeePaymentRequisition />} />

                <Route
                  path={URL.Add_Payment_Requisition}
                  element={<AddEmployeePaymentRequisition />}
                />
                <Route
                  path={":id/edit"}
                  element={<UpdateEmployeePaymentRequisition />}
                />
                <Route
                  path={`:uuId/view`}
                  element={<ViewEmployeePaymentRequisition />}
                />
              </Route>

              <Route path={URL.Vendors} element={<Outlet />}>
                <Route
                  index
                  element={
                    USER_CATEGORY.VENDOR === data?.category ? (
                      <EmployeeViewVendor />
                    ) : (
                      <EmployeeVendorsHome />
                    )
                  }
                />
                <Route
                  path={`:id/${URL.View_Vendor}`}
                  element={<EmployeeViewVendor />}
                />
                {userPermissions.includes(DEFINED_PERMISSIONS.VendorCreate) && (
                  <>
                    <Route
                      path={URL.Add_Vendor}
                      element={<EmployeeAddVendor />}
                    />
                    <Route
                      path={URL.Create_Vendor}
                      element={<EmployeeCreateVendor />}
                    />
                  </>
                )}

                {userPermissions.includes(
                  DEFINED_PERMISSIONS.VendorManager
                ) && (
                  <>
                    <Route path={`:id/edit`} element={<EmployeeEditVendor />} />
                  </>
                )}

                {userPermissions.includes(
                  DEFINED_PERMISSIONS.VendorManager
                ) && (
                  <Route
                    path={`:id/:report/appraise/:type/:reporter/:reporter_department/:report_date`}
                    element={<AppraiseVendor />}
                  />
                )}

                <Route path=":id/appraise/:type" element={<AppraiseVendor />} />
              </Route>

              <Route path={URL.Memo_Requisition} element={<Outlet />}>
                <Route index element={<EmployeeMemoRequisition />} />
                <Route
                  path={URL.Add_Memo_Requisition}
                  element={<AddMemoRequisition />}
                />
                <Route
                  path={`:uuId/view`}
                  element={<ViewEmployeeMemoRequisition />}
                />
              </Route>

              <Route path={URL.Procurement} element={<Outlet />}>
                <Route index element={<EmployeeProcRequisition />} />

                <Route
                  path={URL.Add_Employee_Procurement_Requisition}
                  element={<AddEmployeeProcRequisition />}
                />
                <Route
                  path={":id/edit"}
                  element={<UpdatePaymentRequisition />}
                />
                <Route
                  path={`:uuId/view`}
                  element={<ViewEmployeeProcRequisition />}
                />
              </Route>

              <Route path={URL.Employee_PIP} element={<Outlet />}>
                <Route index element={<EmployeePIP />} />
                <Route
                  path={`:id/view/:referenceId`}
                  element={<ViewEmployeePIP />}
                />
              </Route>

              {/* AuxiliaryServiceRequest */}
              <Route path={URL.Auxiliary_Service_Request} element={<Outlet />}>
                <Route index element={<AuxiliaryServiceRequest />} />

                <Route
                  path={URL.add_auxiliary_service_request}
                  element={<AddAuxiliaryRequest />}
                />
                <Route path={":id/edit"} element={<UpdateAuxiliaryRequest />} />
                <Route path={`:id/view`} element={<ViewAuxiliaryRequest />} />
              </Route>

              <Route path={URL.PerfomanceAppraisal} element={<Outlet />}>
                <Route index element={<PerformanceAppraisal />} />
                <Route path={URL.Peer_Reveiw} element={<Outlet />}>
                  <Route index element={<PeerReview />} />
                  <Route
                    path={`:id/view/:referenceId`}
                    element={<ViewPeerReview />}
                  />
                </Route>
                <Route path={URL.Upward_Review} element={<Outlet />}>
                  <Route index element={<UpwardReview />} />
                  <Route
                    path={`:id/view/:referenceId`}
                    element={<ViewUpwardReview />}
                  />
                </Route>
                <Route path={URL.Cross_Review} element={<Outlet />}>
                  <Route index element={<CrossReview />} />
                  <Route
                    path={`:id/view/:referenceId`}
                    element={<ViewCrossReview />}
                  />
                </Route>
              </Route>

              {/* AuctionBidding */}
              <Route path={URL.AuctionBidding} element={<Outlet />}>
                <Route index element={<AllAuctionBidding />} />
                {/* <Route path={"add"} element={<AddAuctionBidding />} /> */}
                <Route path={`:id/view`} element={<ViewBidding />} />
              </Route>

              <Route path={URL.Self_Appraisal} element={<Outlet />}>
                <Route index element={<SelfAppraisal />} />
                <Route path={`:id/view`} element={<SelfAppraialView />} />
              </Route>

              <Route path={URL.Line_Manager_Appraisal} element={<Outlet />}>
                <Route index element={<LineManagerProcesses />} />
                <Route
                  path={`:id/view/:referenceId`}
                  element={<LineManagerView />}
                />
              </Route>

              <Route path={URL.Weekend_Allowance} element={<Outlet />}>
                <Route index element={<WeekendAllowanceForEmployee />} />

                <Route
                  path={URL.Add_Weekend_Allowance}
                  element={<AddWeekendAllowance />}
                />
                <Route path={":id/edit"} element={<UpdateWeekendAllowance />} />
                <Route
                  path={URL.Weekend_Allowance_Hod}
                  element={<WeekendAllowanceForHod />}
                />
                <Route
                  path={`:uuId/view`}
                  element={<ViewPaymentRequisition />}
                />
              </Route>

              <Route path={URL.Loan_Requisition} element={<Outlet />}>
                <Route index element={<LoanRequisition />} />

                <Route
                  path={URL.Add_Loan_Requisition}
                  element={<AddLoanRequisition />}
                />
                <Route path={":id/edit"} element={<UpdateLoanRequisition />} />
                <Route path={`:id/view`} element={<ViewLoanRequisition />} />
              </Route>

              <Route
                path={URL.Employee_Medical_Requisition}
                element={<Outlet />}
              >
                <Route index element={<EmployeeMedicalRequisition />} />

                <Route
                  path={URL.Add_Employee_Medical_Requisition}
                  element={<AddMedicalRequisition />}
                />
                <Route
                  path={":id/edit"}
                  element={<UpdateMedicalRequisition />}
                />
                <Route path={`:id/view`} element={<ViewMedicalRequisition />} />
              </Route>

              <Route path={URL.Extended_HMO_Claims} element={<Outlet />}>
                <Route index element={<ExtendHMOClaims />} />

                <Route
                  path={URL.Add_Extended_HMO_Claims}
                  element={<AddExtendHMOClaims />}
                />
                <Route path={":id/edit"} element={<UpdateExtendHMOClaims />} />
                <Route path={`:id/view`} element={<ViewExtendHMOClaimss />} />
              </Route>

              <Route path={URL.Training} element={<Outlet />}>
                <Route index element={<EmployeeTrainingRequisitions />} />
                <Route path={"add"} element={<AddTrainingRequisition />} />
                <Route
                  path={`:id/view`}
                  element={<ViewEmployeeTrainingRequisition />}
                />
                <Route
                  path={":id/edit"}
                  element={<EditTrainingRequisition />}
                />
              </Route>

              <Route path={URL.Leave_Requisition} element={<Outlet />}>
                <Route index element={<LeaveRequisition />} />
                <Route path={URL.Add_Leave} element={<AddLeave />} />
                <Route path={":id/edit"} element={<EditLeave />} />
                <Route path={`:id/view`} element={<ViewLeave />} />
                <Route path={`:id/recall`} element={<LeaveRecall />} />
                <Route path={`:id/view`} element={<ViewRecall />} />
              </Route>

              <Route path={URL.Exit_Requisition} element={<Outlet />}>
                <Route index element={<ExitRequisition />} />
                <Route path={`:id/edit`} element={<EditExitRequisition />} />
                <Route path={"add"} element={<AddExitRequisition />} />
                <Route path={`:id/view`} element={<ViewExitRequisition />} />
              </Route>

              <Route path={URL.Exit_HOD} element={<Outlet />}>
                <Route index element={<ExitRequisitionHOD />} />
              </Route>

              <Route path={URL.Exit_Discussion} element={<Outlet />}>
                <Route index element={<ExitDiscussion />} />
                <Route path={"add"} element={<AddExitDisscussion />} />
                <Route path={`:id/view`} element={<ViewExitDiscussion />} />

                {/* <Route path={`:id/edit`} element={<EditRequisition />} /> */}
              </Route>

              <Route path={URL.Overtime_Requisition} element={<Outlet />}>
                <Route index element={<OvertimeRequisition />} />
                <Route
                  path={`:id/view`}
                  element={<ViewOvertimeRequisition />}
                />
              </Route>

              <Route path={URL.Query} element={<Outlet />}>
                <Route index element={<Query />} />

                <Route path={"add"} element={<AddQuery />} />
                <Route path={":id/view"} element={<ViewQuery />} />
                <Route path={":id/edit"} element={<EditQuery />} />
                <Route path={`:id/reply`} element={<AddQueryResponse />} />

                <Route path={URL.Query_Response} element={<Outlet />}>
                  <Route index element={<QueryResponse />} />
                  <Route
                    path={":id/viewreply"}
                    element={<ViewQueryResponse />}
                  />
                </Route>
                <Route
                  path={URL.My_Query_Response}
                  element={<MyQueryResponse />}
                />
              </Route>

              <Route path={URL.Query_By_HOD} element={<QueryByHOD />} />
              <Route path={URL.Query_By_HOC} element={<QueryByHOC />} />
              <Route path={URL.My_Query} element={<MyQuery />} />

              <Route path={URL.My_Employee_Info} element={<Outlet />}>
                <Route index element={<MyEmployeeInfo />} />
                <Route path={"add"} element={<AddNewEmployee />} />
                <Route
                  path={`:id/edit`}
                  element={<EditMyEmployeeInformation />}
                />
                <Route
                  path={`:id/view`}
                  element={<ViewEmployeeInformation />}
                />

                <Route path={URL.My_NOK_Information} element={<Outlet />}>
                  <Route index element={<MyNOKInformation />} />
                  <Route path={URL.Add_My_NOK} element={<AddMyNOK />} />
                  <Route path={":id/edit"} element={<EditMyNOKInformation />} />
                  <Route path={`:id/view`} element={<ViewNOKInformation />} />
                </Route>

                <Route path={URL.My_Medical_Requisition} element={<Outlet />}>
                  <Route index element={<MyMedicalRequisition />} />
                  <Route
                    path={URL.Add_My_Medical}
                    element={<AddMyMedicalRequisition />}
                  />
                  <Route
                    path={`:id/edit`}
                    element={<EditMyMedicalRequisition />}
                  />
                  <Route
                    path={`:id/view`}
                    element={<ViewMyMedicalRequisition />}
                  />
                </Route>

                <Route path={URL.Employee_Qualification} element={<Outlet />}>
                  <Route index element={<EmployeeQualification />} />
                  <Route
                    path={URL.Add_Employee_Qualification}
                    element={<AddEmployeeQualification />}
                  />
                  <Route
                    path={`:id/edit`}
                    element={<EditEmployeeQualification />}
                  />

                  <Route
                    path={`:id/view`}
                    element={<ViewEmployeeQualification />}
                  />
                </Route>
                <Route path={URL.Employee_Referees} element={<Outlet />}>
                  <Route index element={<EmployeeReferee />} />
                  <Route
                    path={URL.Add_Employee_Referee}
                    element={<AddEmployeeReferee />}
                  />

                  <Route path={`:id/edit`} element={<EditEmployeeReferee />} />
                  <Route path={`:id/view`} element={<ViewEmployeeReferee />} />
                </Route>

                <Route path={URL.Employee_Extended_Claim} element={<Outlet />}>
                  <Route index element={<EmployeeExtendedClaim />} />

                  <Route
                    path={URL.Add_Employee_Claim}
                    element={<AddEmployeeExtendedClaim />}
                  />
                  <Route
                    path={`:id/edit`}
                    element={<EditEmployeeExtendedClaim />}
                  />
                  <Route
                    path={`:id/view`}
                    element={<ViewEmployeeExtendedClaim />}
                  />
                </Route>
              </Route>

              <Route path={URL.Payroll} element={<Outlet />}>
                <Route index element={<MyPayroll />} />
                <Route path={URL.Payroll_Run} element={<MyPayrollRun />} />
                <Route
                  path={URL.Staff_Renumeration}
                  element={<StaffRenumeration />}
                />
              </Route>
            </Route>

            <Route path={URL.Relationship} element={<p>Relationship</p>} />
            <Route path={URL.Settings} element={<Outlet />}>
              <Route index element={<p>Page Not Found</p>} />
              {userPermissions.includes(
                DEFINED_PERMISSIONS.PermissionManager
              ) && (
                <>
                  <Route
                    path={URL.Permissions}
                    element={
                      <>
                        <RouteLayout>
                          <Outlet />
                        </RouteLayout>
                      </>
                    }
                  >
                    <Route index element={<Permissions />} />
                    <Route path={URL.Create_Staff} element={<CreateStaff />} />
                    <Route
                      path={`${URL.Edit_Staff}/:id`}
                      element={<CreateStaff isEdit={true} />}
                    />
                    <Route
                      path={`${URL.Edit_Staff_Permissions}/:id`}
                      element={<EditStaffPermission isEdit={true} />}
                    />
                  </Route>
                  <Route
                    path={URL.Permission_Group}
                    element={
                      <>
                        <RouteLayout>
                          <Outlet />
                        </RouteLayout>
                      </>
                    }
                  >
                    <Route index element={<GroupPermissions />} />
                    <Route path={":id"} element={<ViewGroupPermissions />} />
                    <Route path={"add"} element={<AddGroupPermissions />} />
                    <Route
                      path={"update/:id"}
                      element={<AddGroupPermissions isEdit={true} />}
                    />
                  </Route>
                </>
              )}
            </Route>

            {/* finance route */}
            <Route path={URL.finance} element={<Outlet />}>
              {/* {userPermissions.includes(
                  DEFINED_PERMISSIONS.FinanceManager
                ) && ( */}
              <Route path="" element={<Outlet />}>
                <Route index element={<PayrollAutorun />} />
              </Route>
              <Route path={URL.CreateService} element={<CreateNewService />} />
              <Route
                path={URL.AttachAccount}
                element={<AttachAccountDetails />}
              />
              {/* AttachAccountDetails */}
              <Route path={URL.SetupAService} element={<SetupAService />} />
              <Route path={URL.AccountSetup} element={<SetupAnAccount />} />
              <Route
                path={URL.ServiceDetailsView}
                element={<ServiceDetailsView />}
              />
              <Route
                path={URL.AccountDetailsView}
                element={<AccountDetailsView />}
              />
              <Route path={URL.AddFacilities} element={<AddFacilities />} />
              <Route path={URL.UpdateService} element={<UpdateService />} />
              <Route
                path={`${URL.UpdateServiceBookings}/:id`}
                element={<UpdateServiceBookings />}
              />

              <Route path={URL.BookAService} element={<BookAService />} />
              <Route
                path={URL.CreateNewService}
                element={<CreateBookingsA />}
              />
              <Route
                path={URL.BookingsServiceDetails}
                element={<BookingsServiceDetails />}
              />
              <Route
                path={URL.ServiceBookingDetails}
                element={<ServiceBookingDetails />}
              />
              <Route
                path={URL.ManageBookingRequest}
                element={<ManageBookingRequest />}
              />
              <Route
                path={`${URL.ManageBookingRequestView}/:id`}
                element={<ManageBookingRequestView />}
              />

              <Route path={URL.CostCentre} element={<Outlet />}>
                <Route index element={<CostCenter />} />
                <Route
                  path={URL.CostCenterSetup}
                  element={<CostCenterServiceSetup />}
                />
                <Route
                  path={URL.CostCenterClass}
                  element={<CostCenterClass />}
                />
                <Route
                  path={URL.CostCenterClassSetup}
                  element={<CostCenterClassSetup />}
                />
                <Route path={`:id/view`} element={<CostCenterDetails />} />
              </Route>
              <Route path={URL.CostCenterExpenses} element={<Outlet />}>
                <Route index element={<CostCenterExpenses />} />
                <Route
                  path={`employee-view/:data`}
                  element={<CostCenterExpensesDetails />}
                />
              </Route>
              <Route path={URL.CompanyFund} element={<Outlet />}>
                <Route index element={<AnalyseCompanyFunds />} />
                <Route path={`Cashbook`} element={<Cashbook />} />
                <Route
                  path={`UploadBankStatement`}
                  element={<UploadBankStatement />}
                />
                <Route
                  path={`InvestmentRecommendations`}
                  element={<Recommendations />}
                />
                <Route
                  path={`RecommendInvestmentAmount`}
                  element={<RecommendInvestmentAmount />}
                />
                <Route
                  path={`RecommendInvestmentAmount/:id/edit`}
                  element={<RecommendEdit />}
                />
                <Route
                  path={`RecommendInvestmentAmount/:id/view`}
                  element={<ViewRecommendations />}
                />
                <Route path={`Keywords`} element={<Keywords />} />
                <Route path={`SetupKeyword`} element={<SetupKeyword />} />
              </Route>
              <Route path={URL.PayrollAutorun} element={<Outlet />}>
                <Route index element={<PayrollAutorun />} />
              </Route>
              <Route path={`${URL.PayrollAutorun}/payroll`}>
                <Route index element={<PayrollRun />} />
              </Route>
              <Route path={`${URL.PayrollAutorun}/view-staff`}>
                <Route index element={<ViewStaffRemunerations />} />
              </Route>
              <Route path={URL.Payment} element={<Outlet />}>
                <Route index element={<Payment />} />
              </Route>
              <Route path={URL.PaymentSetup} element={<Outlet />}>
                <Route index element={<PaymentSetup />} />
              </Route>
              <Route path={URL.WitholdingTaxSetup} element={<Outlet />}>
                <Route index element={<WitholdingTaxSetup />} />
                <Route path={`:id/view`} element={<WitholdingTaxDetails />} />
              </Route>
              <Route path={URL.ExchangeRateSetup} element={<Outlet />}>
                <Route index element={<ExchangeRateSetup />} />
              </Route>
              <Route path={URL.PaymentRecognitionSetup} element={<Outlet />}>
                <Route index element={<PaymentRecognitionSetup />} />
              </Route>
              <Route path={URL.PaymentSetupHOD} element={<Outlet />}>
                <Route index element={<PaymentSetupHOD />} />
              </Route>
              <Route path={URL.PaymentType} element={<Outlet />}>
                <Route index element={<PaymentType />} />
              </Route>
              <Route path={URL.Narration} element={<Outlet />}>
                <Route index element={<Narration />} />
              </Route>
              <Route path={URL.ManageRoles} element={<Outlet />}>
                <Route index element={<ManageRoles />} />
              </Route>

              {/* payment request */}

              <Route path={URL.PaymentRequest} element={<Outlet />}>
                <Route index element={<PaymentRequest />} />
                <Route
                  path={URL.PaymentRequestHOD}
                  element={<PaymentRequest />}
                />
                <Route
                  path={URL.DownloadPaymentRequest}
                  element={<PaymentRequest />}
                />
                <Route path={URL.PaymentLog} element={<PaymentLog />} />
                <Route path={`control`} element={<PaymentRequestControl />} />
                <Route path={`control2`} element={<PaymentRequestControl2 />} />
                <Route
                  path={`Payment-Details/:data`}
                  element={<PaymentDetails />}
                />
              </Route>

              {/* Payment Service Setup */}
              <Route path={URL.PaymentService} element={<Outlet />}>
                <Route index element={<PaymentServiceIndex />} />

                <Route
                  path="payment_service_setup/:id"
                  element={<PaymentService />}
                />
                <Route
                  path="setup_payment_limit"
                  element={<SetupPaymentLimit />}
                />
                <Route
                  path="request_history"
                  element={<PaymentServiceHistory />}
                />
                <Route
                  path="create_payment_setup"
                  element={<CreatePaymentSetup />}
                />
                <Route
                  path="create_payment_subclass"
                  element={<CreatePaymentSubclass />}
                />
                <Route
                  path="create_subclass_component"
                  element={<CreateSubclassComp />}
                />
                <Route
                  path="payment_setup_detail/:id"
                  element={<DetailPaymentSetup />}
                />
                <Route
                  path="payment_subclass_detail/:id"
                  element={<DetailPaymentSubclass />}
                />
                <Route
                  path="payment_scomponent_detail/:id"
                  element={<DetailPaymentComp />}
                />
                <Route
                  path="update_payment_setup/:id"
                  element={<EditPaymentSetup />}
                />
                <Route
                  path="update_payment_subclass/:id"
                  element={<EditPaymentSubclass />}
                />
                <Route
                  path="update_subclass_component/:id"
                  element={<UpdateSubclassComp />}
                />
                <Route
                  path="update_payment_limit/:id"
                  element={<UpdatePaymentLimit />}
                />

                {/* <Route
                      path={URL.Create_Staff}
                      element={<CreateStaff />}
                    /> */}

                {/* )} */}
              </Route>

              {/* <Route
                  path={`/dashboard/Asset-Setup/depreciation`}
                  element={<Outlet />}
                >
                  <Route index element={<AssetDepreciation />} />
                </Route> */}
              <Route path={URL.CooperativeSetup} element={<Outlet />}>
                <Route index element={<CooperativeSetup />} />
              </Route>
              <Route path={URL.CooperativeComponent} element={<Outlet />}>
                <Route index element={<CooperativeComponent />} />
              </Route>
              <Route path={URL.CreateCooperativeComponent} element={<Outlet />}>
                <Route index element={<CreateCooperativeComponent />} />
              </Route>
              <Route path={URL.CooperativeSetupDetails} element={<Outlet />}>
                <Route index element={<CooperativeSetupDetails />} />
              </Route>
              <Route path={URL.AssignCooperativeReviewer} element={<Outlet />}>
                <Route index element={<EditCooperativeSetup />} />
              </Route>
              <Route path={URL.BudgetImport} element={<Outlet />}>
                <Route index element={<BudgetImport />} />
              </Route>
              <Route element={<Outlet />}>
                <Route
                  index
                  path="Budget-Import/BudgetImportDetails/:id"
                  element={<BudgetImportDetails />}
                />
              </Route>
              <Route element={<Outlet />}>
                <Route
                  index
                  path="Budget-Import/BudgetImportDetails/:id/view"
                  element={<BudgetImportDetailsView />}
                />
              </Route>
              <Route path={URL.AssetNBV} element={<Outlet />}>
                <Route index element={<AssetDepreciation />} />
              </Route>
              <Route path={URL.CooperativeManagement} element={<Outlet />}>
                <Route index element={<CooperativeManagement />} />
              </Route>
              <Route
                path={URL.CooperativeManagementReviewer}
                element={<CooperativeManagementReviewer />}
              >
                <Route index element={<CooperativeManagement />} />
              </Route>
              <Route
                element={<Outlet />}
                path={URL.CooperativeManagementReviewerDetails}
              >
                <Route
                  index
                  element={<CooperativeManagementReviewerDetails />}
                />
              </Route>
              <Route
                element={<Outlet />}
                path={URL.CooperativeManagementApprovalDetails}
              >
                <Route
                  index
                  element={<CooperativeManagementApprovalDetails />}
                />
              </Route>

              <Route
                path={URL.CooperativeManagementApproval}
                element={<Outlet />}
              >
                <Route index element={<CooperativeManagementApproval />} />
              </Route>

              {/* TODO */}
              <Route
                path={URL.NonStatutoryAdviceManagement}
                element={<Outlet />}
              >
                <Route index element={<NonStatutoryAdviceManagement />} />
              </Route>
              <Route
                path={URL.NonStatutoryAdviceReviewer}
                element={<NonStatutoryAdviceReviewer />}
              >
                <Route index element={<NonStatutoryAdviceManagement />} />
              </Route>
              <Route
                element={<Outlet />}
                path={URL.NonStatutoryAdviceReviewerDetails}
              >
                <Route index element={<NonStatutoryAdviceReviewerDetails />} />
              </Route>
              <Route
                element={<Outlet />}
                path={URL.NonStatutoryAdviceApprovalDetails}
              >
                <Route index element={<NonStatutoryAdviceApprovalDetails />} />
              </Route>

              <Route path={URL.NonStatutoryAdviceApproval} element={<Outlet />}>
                <Route index element={<NonStatutoryAdviceApproval />} />
              </Route>
              {/* )} */}

              {/* Accounting Ledger Setup */}
              <Route path={URL.AccountingLedgerSetup} element={<Outlet />}>
                <Route index element={<AccountingSetupIndex />} />
                <Route path="create_coa" element={<CreateCOA />} />
                <Route path="create_acct" element={<CreateAccountingAcct />} />
                <Route path="create_sub_acct" element={<CreateSubAcct />} />
                <Route path="update-group/:id" element={<UpdateGroup />} />
                <Route
                  path="update-Subgroup/:id"
                  element={<UpdateSubgroup />}
                />

                <Route path="pending_approval" element={<PendingApproval />} />
              </Route>

              {/* Accounting Ledger */}
              <Route path={URL.AccountingLedger} element={<Outlet />}>
                <Route index element={<AccountingLedger />} />
                <Route path="senior_accoutant" element={<SeniorAccountant />} />
                <Route
                  path="pending_approval"
                  element={<PendingApprovalTwo />}
                />
              </Route>

              {/* Credit Facility */}
              <Route path={URL.CreditFacility} element={<Outlet />}>
                <Route index element={<CreditFacility />} />
                <Route
                  path={URL.AddCreditFacility}
                  element={<AddCreditFacility />}
                />
                <Route
                  path={URL.VeiwCreditFacility}
                  element={<ViewIndividualCreditFacility />}
                />
                {/* <Route path="senior_accoutant" element={<SeniorAccountant />} />
                <Route
                  path="pending_approval"
                  element={<PendingApprovalTwo />}
                /> */}
              </Route>

              <Route path={"*"} element={<p>Not Found</p>} />
            </Route>
            <Route path={"*"} element={<p>Not Found</p>} />
            <Route path={"*"} element={<p>The Page Not Found</p>} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}

export default Main;
